import React, { useState, useEffect, useRef, useCallback } from "react";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import ZoomDropdown from "../components/ZoomDropdown";
import logo from "../assets/logo.png";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import {
  Grid2,
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  DialogContent,
  DialogTitle,
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  fabClasses,
  ListItem,
  ListItemText,
  Chip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import SignatureModalContent from "../components/SignatureModalContent";
import { format, parse, isValid } from "date-fns";
import FileUpload from "../components/FileUpload";
import "../styles/App.styles.css";
import "../App.css";
import { Rnd } from "react-rnd";
import TabsComponent from "../components/TabsComponent";
import ForYou from "../components/ForYou";
import ForOthers from "../components/ForOthers";
import TextPropertiesPanel from "../components/TextPropertiesPanel";
import DatePickerComponent from "../components/DatePickerComponent";
import EditIcon from "@mui/icons-material/Edit";
import ImageCropperModal from "../components/ImageCropperModal";
import AddIcon from "@mui/icons-material/Add";
import SignersDialog from "../components/SignersDialog";
import SignerFieldProperties from "../components/SignerFieldProperty";
import {
  downloadOriginalPdf,
  getColorWithNewOpacity,
  getSignerBoxContent,
  getSignerBoxContentSvg,
  hashIds,
  saveData,
  unhashIds,
} from "../components/utlis";
import { FrontendBaseUrl, post, postFormData } from "../apis/apis";
import DropdownPropertiesPanel from "../components/DropdownPropertiesPanel";
import toastAlert from "../components/toastAlert";
import getActivityLogUserFiles from "../components/getActivityLogUserFiles";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

function EsignSetupView() {
  const [textFieldHistory, setTextFieldHistory] = useState({});
  const [activePage, setActivePage] = useState(1); // Track active page

  const [pageSizes, setPageSizes] = useState({});
  const [globalIsRequired, setGlobalIsRequired] = useState(false);
  const [textFieldMetrics, setTextFieldMetrics] = useState({
    width: 120,
    height: 30,
  });
  const [annotationSettings, setAnnotationSettings] = useState({
    my_text: {
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "#000000",
      format: [],
      letterSpacing: 0,
      alignment: "left",
      opacity: 1,
      width: 120,
      height: 30,
    },
    signer_text: {
      fontSize: 16,
      fontFamily: "Helvetica",
      isRequired: false,
      width: 150,
      height: 30,
    },
    signer_initials: {
      isRequired: false,
      width: 250,
      height: 100,
    },
    signer_initials_text: {
      isRequired: false,
      width: 100,
      height: 100,
    },
    signer_date: {
      isRequired: false,
      dateFormat: "MMM dd, yyyy",
      width: 150,
      height: 30,
    },
    signer_checkmark: {
      isRequired: false,
      width: 30,
      height: 30,
    },
    signer_dropdown: {
      isRequired: false,
      options: [],
      width: 150,
      height: 30,
    },
  });
  // Add new state at the top of App component
  const [signerToEdit, setSignerToEdit] = useState(null);
  const [loadingStamps, setLoadingStamps] = useState({});

  const [pageNoClicked, setPageNoClicked] = useState(null);
  const styles = {
    sidebarStyle: {
      cursor: "default !important",
      "& *": {
        cursor: "default !important",
      },
      "& button": {
        cursor: "pointer !important",
      },
      "& .thumbnail-container": {
        cursor: "pointer !important",
      },
    },
  };
  // const handlePageHover = useCallback((pageNum) => {
  //   const thumbnailElement = document.getElementById(`thumbnail-${pageNum}`);
  //   if (thumbnailElement && sidebarRef.current) {
  //     thumbnailElement.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "nearest",
  //     });
  //     setActivePage(pageNum);
  //   }
  // }, []);
  // const setupIntersectionObserver = useCallback((options) => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.intersectionRatio > 0) {
  //           // Changed from isIntersecting to intersectionRatio
  //           const pageNum = parseInt(entry.target.id.split("-")[1]);
  //           setActivePage(pageNum);
  //           const thumbnailElement = document.getElementById(
  //             `thumbnail-${pageNum}`
  //           );
  //           if (thumbnailElement && sidebarRef.current) {
  //             thumbnailElement.scrollIntoView({
  //               behavior: "auto",
  //               block: "nearest",
  //               inline: "nearest",
  //             });
  //           }
  //         }
  //       });
  //     },
  //     {
  //       ...options,
  //       threshold: [0, 0.1, 0.5], // Add more thresholds for better detection
  //       rootMargin: "0px", // Adjust rootMargin for earlier detection
  //     }
  //   );

  //   document.querySelectorAll('[id^="img-"]').forEach((element) => {
  //     observer.observe(element);
  //   });

  //   return observer;
  // }, []);

  // // Add a scroll event listener for fast scrolling
  // useEffect(() => {
  //   const pdfContainer = pdfContainerRef.current;
  //   if (!pdfContainer) return;

  //   const handleScroll = debounce((e) => {
  //     const container = e.target;
  //     const containerRect = container.getBoundingClientRect();
  //     const elements = document.querySelectorAll(".pdf-page-container");

  //     elements.forEach((element) => {
  //       const rect = element.getBoundingClientRect();
  //       const isVisible =
  //         rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;

  //       if (isVisible) {
  //         const pageNum = parseInt(element.id.split("-")[1]);
  //         handlePageHover(pageNum);
  //       }
  //     });
  //   }, 16); // 60fps throttle

  //   pdfContainer.addEventListener("scroll", handleScroll);
  //   return () => pdfContainer.removeEventListener("scroll", handleScroll);
  // }, [handlePageHover]);

  // // Add debounce utility function
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  // check

  useEffect(() => {
    const pdfContainer = pdfContainerRef.current;
    if (!pdfContainer) return;

    const handleScroll = debounce((e) => {
      const container = e.target;
      const containerRect = container.getBoundingClientRect();
      const elements = document.querySelectorAll(".pdf-page-container");

      let detectedPage = null;

      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const isVisible =
          rect.top >= containerRect.top && rect.bottom <= containerRect.bottom;

        if (isVisible && !detectedPage) {
          detectedPage = parseInt(element.id.split("-")[1]);
        }
      });

      if (detectedPage) {
        setActivePage(detectedPage);
      }
    }, 16); // 60fps debounce

    pdfContainer.addEventListener("scroll", handleScroll);
    return () => pdfContainer.removeEventListener("scroll", handleScroll);
  }, []);

  const setupIntersectionObserver = useCallback((options) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.5) {
            const pageNum = parseInt(entry.target.id.split("-")[1]);
            setActivePage(pageNum);
          }
        });
      },
      {
        ...options,
        threshold: [0.5], // Fire when 50% of page is visible
      }
    );

    document.querySelectorAll(".pdf-page-container").forEach((element) => {
      observer.observe(element);
    });

    return observer;
  }, []);

  const scrollThumbnailIntoView = (pageNum) => {
    const thumbnailElement = document.getElementById(`thumbnail-${pageNum}`);

    if (thumbnailElement && sidebarRef.current) {
      thumbnailElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  };
  useEffect(() => {
    // if (sidebarVisible) {
    scrollThumbnailIntoView(activePage);
    // }
  }, [activePage]);

  const handlePageHover = (pageNum) => {
    setActivePage(pageNum); // Nothing else!
  };

  // endf
  const handleEditSigner = (signer, event) => {
    event.stopPropagation(); // Prevent dropdown from closing
    setSignersDialogOpen(true);
    // You'll need to add logic in SignersDialog to handle editing mode
    // Pass the signer to edit through props
    const signerIndex = signers.findIndex((s) => s.id === signer.id);
    setSignerToEdit({ signer, index: signerIndex }); // Add this state
  };
  const colortheme = "rgb(35, 179, 232)";
  const [pdfFile, setPdfFile] = useState(null);
  const [scale, setScale] = useState(1); // Changed initial scale to 0.8
  const [pdfImages, setPdfImages] = useState([]);
  useEffect(() => {
    const updatePageSizes = () => {
      const newSizes = {};
      pdfImages.forEach((_, pageIndex) => {
        const pageElement = document.getElementById(`img-${pageIndex + 1}`);
        if (pageElement) {
          newSizes[pageIndex + 1] = {
            width: pageElement.clientWidth,
            height: pageElement.clientHeight,
          };
        }
      });
      setPageSizes(newSizes);
    };

    updatePageSizes();

    window.addEventListener("resize", updatePageSizes);
    return () => window.removeEventListener("resize", updatePageSizes);
  }, [pdfImages, scale]);
  const [containerWidth, setContainerWidth] = useState(0);
  const [firstPageHeight, setFirstPageHeight] = useState(null);
  // At the top with other state declarations
  const [annotationType, setAnnotationType] = useState(null); // 'text' or 'image'
  // Modify the annotations state to store per-page annotations
  const [annotations, setAnnotations] = useState({}); // Changed from array to object with page keys
  const [isAnnotating, setIsAnnotating] = useState(false);
  const [focusedAnnotation, setFocusedAnnotation] = useState(null);
  const [active, setActive] = useState("1");
  const [selectedSigner, setSelectedSigner] = useState([]);
  // First, add a state for storing click position
  const [stampClickPosition, setStampClickPosition] = useState(null);
  // Add this state in your App component
  const [signersDialogOpen, setSignersDialogOpen] = useState(false);
  const [signers, setSigners] = useState([]);
  // Inside your App.js, add this state
  const [selectedSignerId, setSelectedSignerId] = useState(null);
  // Add these helper functions

  // Add these states in your App component
  const [signatureModalOpen, setSignatureModalOpen] = useState(false);
  const getTypeListItem = (type) => {
    setIsAnnotating(true);
    setAnnotationType(type);
  };

  const [initialsBox, setInitialBox] = useState(false);
  const pdfContainerRef = useRef(null);
  const sidebarRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const getSignerColorById = (signerId, signers) => {
    const signer = signers.find(
      (s) => s.signer_id === signerId || s.id === signerId
    );
    return signer?.color || "rgba(0, 0, 0, 0.1)"; // Default color if signer not found
  };
  // Add this component inside your EsignSetupView component
  const FullScreenLoader = () => (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(3, 3, 3, 0.8)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: "rgb(35, 179, 232)",
          marginBottom: 2,
        }}
      />
      <Typography variant="h6" color="textSecondary" style={{ color: "white" }}>
        Loading Document...
      </Typography>
    </Box>
  );

  // Add new state at the top of your App component
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);

  const annotationRefs = useRef({}); // Store refs for each annotation
  const cursorRef = useRef(null);
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const [activeAnnotationId, setActiveAnnotationId] = useState(null);

  const textAnnotationTypes = ["my_text", "signer_text", "date"];
  // states
  const [fileName, setFileName] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [securedShare, setSecuredShare] = useState(false);
  const [statusFile, setStatusFile] = useState("");
  const [uniqIdDoc, setUniqIdDoc] = useState("");

  const isTextAnnotation = textAnnotationTypes?.includes(annotationType);
  const selectedAnnotationType =
    textAnnotationTypes.includes(selectedAnnotation);
  const [stampInputRef] = useState(React.createRef());
  // Add these states at the top of your App component
  const [cropperModalOpen, setCropperModalOpen] = useState(false);
  const [cropSrc, setCropSrc] = useState(null);
  const [pendingStampAction, setPendingStampAction] = useState(null);

  // const handleStampFileSelect = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     setCropSrc(e.target.result);
  //     setPendingStampAction({
  //       isEdit: !!editingAnnotation,
  //       editData: editingAnnotation,
  //       newStampPosition: stampClickPosition,
  //     });
  //     setCropperModalOpen(true);
  //   };
  //   reader.readAsDataURL(file);
  //   event.target.value = "";
  // };
  const handleStampFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Create temporary loading annotation
    if (pageNoClicked && stampClickPosition) {
      const tempAnnotation = {
        id: Date.now(),
        x: stampClickPosition.x,
        y: stampClickPosition.y,
        type: "stamp",
        // width: 150 / scale,
        // height: 150 / scale,
        width: stampClickPosition.width,
        height: stampClickPosition.height,
        isLoading: true,
        page_no: pageNoClicked,
      };

      // Add temporary annotation with loader
      setAnnotations((prev) => ({
        ...prev,
        [pageNoClicked]: [...(prev[pageNoClicked] || []), tempAnnotation],
      }));
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setCropSrc(e.target.result);
      setPendingStampAction({
        isEdit: !!editingAnnotation,
        editData: editingAnnotation,
        newStampPosition: stampClickPosition,
      });
      setCropperModalOpen(true);
    };
    reader.readAsDataURL(file);
    event.target.value = "";
  };
  // Add handler for cropped image
  const handleCroppedStamp1 = (croppedImage) => {
    const img = new Image();
    img.onload = () => {
      const defaultWidth = 150;
      const aspectRatio = img.width / img.height;
      const defaultHeight = defaultWidth / aspectRatio;

      if (pendingStampAction.isEdit) {
        // Handle editing existing stamp
        setAnnotations((prev) => {
          const updatedAnnotations = { ...prev };
          const { pageNum, index } = pendingStampAction.editData;

          const existingAnnot = updatedAnnotations[pageNum][index];
          updatedAnnotations[pageNum][index] = {
            ...existingAnnot,
            imageUrl: croppedImage,
            height: existingAnnot.width / aspectRatio,
          };

          return updatedAnnotations;
        });
        setEditingAnnotation(null);
      } else {
        // Handle new stamp creation
        const newAnnotation = {
          id: Date.now(),
          x: pendingStampAction.newStampPosition.x,
          y: pendingStampAction.newStampPosition.y,
          type: "stamp",
          page_no: pageNoClicked,
          imageUrl: croppedImage,
          width: defaultWidth / scale,
          height: defaultHeight / scale,
        };

        setAnnotations((prev) => {
          const updatedAnnotations = {
            ...prev,
            [activePage]: [...(prev[activePage] || []), newAnnotation],
          };

          const newIndex = updatedAnnotations[activePage].length - 1;
          setActiveAnnotation(`${activePage}-${newIndex}`);

          return updatedAnnotations;
        });
      }

      // Reset states
      setCropperModalOpen(false);
      setCropSrc(null);
      setPendingStampAction(null);
      setStampClickPosition(null);
    };
    img.src = croppedImage;
  };
  // Update handleCroppedStamp function
  const handleCroppedStamp = async (croppedImage) => {
    try {
      // Upload cropped image
      const base64Response = await fetch(croppedImage);
      const blob = await base64Response.blob();
      const fileObject = new File([blob], "stamp.png", { type: "image/png" });

      const postData = {
        image: fileObject,
        user_id: userId,
      };

      const apiData = await postFormData(postData);

      if (!apiData.public_url) {
        toastAlert("error", "Error uploading stamp");
        return;
      }

      const ImageUrl = apiData.public_url;

      if (pendingStampAction.isEdit) {
        // Handle editing existing stamp
        setAnnotations((prev) => {
          const updatedAnnotations = { ...prev };
          const { pageNum, index } = pendingStampAction.editData;

          const existingAnnot = updatedAnnotations[pageNum][index];
          updatedAnnotations[pageNum][index] = {
            ...existingAnnot,
            imageUrl: ImageUrl,
            isLoading: false,
          };

          return updatedAnnotations;
        });
      } else {
        // Handle new stamp
        setAnnotations((prev) => {
          const pageAnnotations = prev[pageNoClicked] || [];
          const loadingIndex = pageAnnotations.findIndex((a) => a.isLoading);

          if (loadingIndex !== -1) {
            const newAnnotations = [...pageAnnotations];
            newAnnotations[loadingIndex] = {
              ...newAnnotations[loadingIndex],
              imageUrl: ImageUrl,
              isLoading: false,
            };

            return {
              ...prev,
              [pageNoClicked]: newAnnotations,
            };
          }

          return prev;
        });
      }

      // Reset states
      setCropperModalOpen(false);
      setCropSrc(null);
      setPendingStampAction(null);
      setStampClickPosition(null);
    } catch (error) {
      console.error("Error handling stamp:", error);
      toastAlert("error", "Error uploading stamp");

      // Clean up loading annotation on error
      setAnnotations((prev) => {
        const pageAnnotations = prev[pageNoClicked] || [];
        return {
          ...prev,
          [pageNoClicked]: pageAnnotations.filter((a) => !a.isLoading),
        };
      });
    }
  };
  const calculateZoomPercentage = useCallback((scaleValue) => {
    // return Math.round((scaleValue / 0.8) * 100);
    return Math.round(scaleValue * 100);
  }, []);

  const calculateImageWidth = useCallback((scaleValue) => {
    const baseWidth = 100;

    // Simple screen size detection
    const isLargeScreen = window.innerWidth >= 1920; // 4K, ultrawide monitors
    const isLaptop = window.innerWidth >= 1440 && window.innerWidth < 1920;

    let effectiveScale = scaleValue;

    if (isLargeScreen) {
      // For large screens, cap the scale to prevent oversized PDFs
      // effectiveScale = Math.min(scaleValue, 1.0);
      effectiveScale = 0.9;
    } else if (isLaptop) {
      // For laptop screens, use scale as intended
      effectiveScale = scaleValue;
    }

    const scaledWidth = baseWidth * effectiveScale;
    return Math.max(scaledWidth, 50);
  }, []);
  // Memoize container width update
  const updateContainerWidth = useCallback(() => {
    if (pdfContainerRef.current) {
      setContainerWidth(pdfContainerRef.current.offsetWidth);
    }
  }, []);
  // Add these constants at the top of your file
  const RESIZE_HANDLES = {
    // bottom: true,
    // bottomLeft: true,
    bottomRight: true,
    // left: true,
    // right: true,
    // top: true,
    // topLeft: true,
    // topRight: true,
  };

  // Combine container width and resize effects
  useEffect(() => {
    updateContainerWidth();
    window.addEventListener("resize", updateContainerWidth);
    return () => window.removeEventListener("resize", updateContainerWidth);
  }, [updateContainerWidth, scale]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSelectedAnnotation(null);
        setAnnotationType(null);
        setIsAnnotating(false);
      }
    };

    // Add event listener when the component mounts
    document.body.addEventListener("keydown", handleKeyDown);

    // Remove event listener when the component unmounts
    return () => {
      document.body.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const loadPdfFromUrl = async (url) => {
    try {
      const response = await fetch(url);
      const pdfBlob = await response.blob();
      setPdfFile(pdfBlob);
      await convertPdfToImages(pdfBlob);
    } catch (error) {
      console.error("Error loading PDF from URL:", error);
    }
  };

  // Update the convertPdfToImages function
  const convertPdfToImages = useCallback(async (file) => {
    try {
      let pdfData;
      if (file instanceof Blob) {
        // If file is already a Blob (from file upload)
        pdfData = await file.arrayBuffer();
      } else {
        // If file is a URL
        const response = await fetch(file);
        pdfData = await response.arrayBuffer();
      }

      const loadingTask = pdfjs.getDocument({ data: pdfData });
      const pdf = await loadingTask.promise;
      const images = await Promise.all(
        Array.from({ length: pdf.numPages }, async (_, i) => {
          const page = await pdf.getPage(i + 1);
          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({
            canvasContext: context,
            viewport,
          }).promise;

          return canvas.toDataURL("image/png");
        })
      );

      setPdfImages(images);
      setIsLoading(false);
    } catch (error) {
      console.error("Error converting PDF:", error);
    }
  }, []);
  // hashed
  const [documentId, setDocumentId] = useState(null);
  const [userId, setUserId] = useState(null);
  // Function to generate hashed URL
  const generateHashedUrl = (documentId, userId) => {
    const data = { documentId, userId };
    const hashedData = hashIds(data);
    const baseUrl = window.location.origin + window.location.pathname;
    return `${baseUrl}?data=${hashedData}`;
  };

  // Example usage:
  const shareDocument = () => {
    // fileid   user id
    const hashedUrl = generateHashedUrl("116676", "116625");
    // Now you can share this URL
    console.log("Shareable URL:", hashedUrl);
  };
  // funxtions
  const fetchFileData = async (fileId, user_id) => {
    // get Images from db
    console.log("user_iudsfjsf");
    console.log(user_id);
    const postData = {
      file_id: fileId,
      user_id: user_id,
    };
    const apiData = await post("file/get-file", postData); // Specify the endpoint you want to call
    console.log("File Dta Fetch");

    console.log(apiData);
    // setUniqIdDoc(apiData.data.uniq_id)
    if (apiData.error) {
      // window.location.href = "/error";
      toastAlert("error", "No File exist");
    } else {
      // toastAlert("success", "File exist")
      setFileName(apiData?.data?.name || "");

      // end
      //console.log('dfdf');
      //console.log(apiData.data.only_signer);
      setEmailMessage(
        apiData?.data?.email_message ||
          `Please review and e-sign the document ${apiData?.data?.name} at your earliest convenience. Thank you!`
      );
      setEmailSubject(`Request for Signature: ${apiData?.data?.name}`);
      setUniqIdDoc(apiData?.data?.uniq_id);
      setSecuredShare(apiData.data.secured_share || false);
      // setSignerFunctionalControls(
      //   apiData.data.signer_functional_controls || true
      // );
      // setSetEsignOrder(apiData.data.esign_order || false);
      setStatusFile(apiData.data.status || "");
    }
  };
  const [user_email, setUserEmail] = useState("");
  const fetchuser = async (user_id) => {
    // get Images from db
    console.log("user_iudsfjsf");
    console.log(user_id);
    const postData = {
      user_id: user_id,
    };
    const apiData = await post("user/getUser1ById", postData); // Specify the endpoint you want to call
    console.log("get user");

    console.log(apiData);
    // setUniqIdDoc(apiData.data.uniq_id)
    if (apiData.error) {
      // window.location.href = "/error";
      toastAlert("error", "No USER exist");
    } else {
      setUserEmail(apiData?.result[0]?.email || "");
      // toastAlert("success", "File exist")
    }
  };
  // const UpdateLastChange = async (fileId) => {
  //   const location = await getUserLocation();
  //   const postData = {
  //     file_id: fileId,
  //     last_change: location?.date,
  //   };
  //   try {
  //     const apiData = await post("file/updateLastChange", postData); // Specify the endpoint you want to call
  //     console.log("Update Last Change");

  //     console.log(apiData);
  //   } catch (error) {
  //     //console.log('Error fetching data:', error);
  //   }
  // };
  // const fetchRecipientsData = async (fileId) => {
  //   const postData = {
  //     file_id: fileId,
  //   };
  //   try {
  //     const apiData = await post("file/getAllRecipientsByFileId", postData); // Specify the endpoint you want to call
  //     //console.log('Recipients');

  //     //console.log(apiData);
  //     if (apiData.error === true || apiData.error === "true") {
  //       setRecipientsData([]);
  //       setCountReceipient(apiData.result.length);
  //     } else {
  //       setRecipientsData(apiData.result);
  //       setCountReceipient(apiData.result.length);
  //     }
  //   } catch (error) {
  //     //console.log('Error fetching data:', error);
  //   }
  // };
  const fetchSignerData = async (fileId) => {
    const postData = {
      file_id: fileId,
    };
    try {
      const apiData = await post("file/getAllSignersByFileId", postData); // Specify the endpoint you want to call
      console.log("Signers ");

      console.log(apiData);
      if (apiData.error) {
        setSigners([]);
        setSelectedSigner([]);
        setActive("1");
        // setCount(0);
      } else {
        // if(apiData)
        setSigners(apiData.result);
        setSelectedSigner(apiData.result[apiData.result.length - 1]);

        // setSelectedSigner(apiData.result[0]);
        // setCount(apiData.result.length);
      }
    } catch (error) {
      //console.log('Error fetching data:', error);
    }
  };
  // const fetchDataPositions = async (fileId) => {
  //   // get positions from db
  //   const postData = {
  //     file_id: fileId,
  //   };
  //   const apiData = await post("file/getallPositionsFromFile_Id", postData); // Specify the endpoint you want to call
  //   console.log("Position Data");

  //   console.log(apiData);
  //   // if (apiData.error) {
  //   // } else {
  //   //   const positionsData = apiData.result[0]?.position_array;
  //   //console.log('positions');
  //   // console.log(apiData.result);
  //   // const annotationsForDatabase = {
  //   //   1: positionsData,
  //   // };
  //   // setAnnotations(annotationsForDatabase);
  //   if (!apiData.error && apiData.result?.[0]?.position_array) {
  //     const positionsData = apiData.result[0].position_array;

  //     // Parse the JSON string from database
  //     let parsedPositions;
  //     if (typeof positionsData === "string") {
  //       parsedPositions = JSON.parse(positionsData);
  //     } else {
  //       parsedPositions = positionsData;
  //     }

  //     // Group annotations by page number
  //     const groupedAnnotations = {};
  //     parsedPositions.forEach((annotation) => {
  //       const pageNo = annotation.page_no || 1; // Default to page 1 if not specified
  //       if (!groupedAnnotations[pageNo]) {
  //         groupedAnnotations[pageNo] = [];
  //       }
  //       groupedAnnotations[pageNo].push(annotation);
  //     });

  //     setAnnotations(groupedAnnotations);
  //   } else {
  //     setAnnotations({});
  //   }
  //   // }
  // };
  const fetchDataPositions = async (fileId) => {
    try {
      const postData = {
        file_id: fileId,
      };

      const apiData = await post("file/getallPositionsFromFile_Id", postData);
      console.log("Position Data");
      console.log(apiData);
      if (!apiData.error && apiData.result?.[0]?.position_array) {
        let positionsData = apiData.result[0].position_array;
        console.log("pos");

        // Parse if string
        if (typeof positionsData === "string") {
          positionsData = JSON.parse(positionsData);
        }

        // Group by page number
        const groupedAnnotations = positionsData.reduce((acc, annotation) => {
          const pageNum = annotation.page_no || 1;
          if (!acc[pageNum]) {
            acc[pageNum] = [];
          }

          // Ensure all required properties are present
          const formattedAnnotation = {
            id: annotation.id,
            type: annotation.type,
            x: annotation.x,
            y: annotation.y,
            width: annotation.width || 150,
            height: annotation.height || 30,
            text: annotation.text || "",
            checked: annotation.checked || false,
            imageUrl: annotation.imageUrl || null,
            format: annotation.format || [],
            fontSize: annotation.fontSize || 16,
            fontFamily: annotation.fontFamily || "Helvetica",
            backgroundColor: annotation.backgroundColor || null,
            borderColor: annotation.borderColor || null,
            signerId: annotation.signerId || null,
            signerColor: annotation.signerColor || null,
            isRequired: annotation.isRequired || false,
            page_no: pageNum,
          };

          acc[pageNum].push(formattedAnnotation);
          return acc;
        }, {});

        setAnnotations(groupedAnnotations);
      }

      return {};
    } catch (error) {
      console.error("Error fetching positions:", error);
      return {};
    }
  };
  // Modify your useEffect to include the loader
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hashedParams = params.get("data");

    if (hashedParams) {
      const unhashedData = unhashIds(hashedParams);
      if (unhashedData) {
        const { documentId, userId } = unhashedData;
        setDocumentId(documentId);
        setUserId(userId);

        // Create an async function to handle all API calls
        const fetchAllData = async () => {
          try {
            setIsLoading(true); // Show loader
            await fetchFileData(documentId, userId);
            await fetchuser(userId);
            await fetchData(documentId);
            // await fetchDataPositions(documentId);
            await fetchSignerData(documentId);
          } catch (error) {
            console.error("Error fetching data:", error);
            toastAlert("error", "Error loading document data");
          } finally {
            // setIsLoading(false); // Hide loader
          }
        };

        fetchAllData();
      }
    }
  }, []);
  // Usage example - call this when component mounts or when URL is available
  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const hashedParams = params.get("data");

  //   if (hashedParams) {
  //     const unhashedData = unhashIds(hashedParams);
  //     if (unhashedData) {
  //       const { documentId, userId } = unhashedData;
  //       setDocumentId(documentId);
  //       setUserId(userId);

  //       // Create an async function to handle all API calls
  //       const fetchAllData = async () => {
  //         try {
  //           await fetchFileData(documentId, userId);
  //           await fetchuser(userId);
  //           await fetchData(documentId);
  //           await fetchDataPositions(documentId);
  //           await fetchSignerData(documentId);
  //         } catch (error) {
  //           console.error("Error fetching data:", error);
  //           toastAlert("error", "Error loading document data");
  //         }
  //       };

  //       fetchAllData();
  //     }
  //   }
  // }, []); // Add dependencies as needed
  const [originalPdf, setOriginalPdf] = useState("");
  const [completedDoc, setCompletedDoc] = useState("");
  const fetchData = async (fileId) => {
    // get Images from db
    const postData = {
      file_id: fileId,
    };
    const apiData = await post("file/getbgImagesByFileId", postData); // Specify the endpoint you want to call
    console.log("apixxsData");

    console.log(apiData);
    if (apiData.error) {
      // setIsLoadingDoc(false);
    } else {
      const pdfUrl = apiData?.result[0]?.inprocess_doc;
      const pdfUrlOriginal = apiData?.result[0]?.image;
      console.log("pdf", pdfUrl);
      console.log("pdfud", pdfUrlOriginal);

      setOriginalPdf(pdfUrlOriginal);
      setCompletedDoc(pdfUrl);
      // const pdfUrl = `https://y5f8.c1.e2-7.dev/requiresign-testing-bucket/${documentId}/document.pdf`;
      loadPdfFromUrl(pdfUrl);
      // setImageUrls(apiData.result[0].image);
      // setIsLoadingDoc(false);
      // setIsLoaded(false);
    }
  };
  const handleFileUpload = (fileOrUrl) => {
    if (typeof fileOrUrl === "string") {
      // If it's a URL
      loadPdfFromUrl(fileOrUrl);
    } else {
      // If it's a File object
      setPdfFile(fileOrUrl);
      convertPdfToImages(fileOrUrl);
    }
  };
  const [activeAnnotation, setActiveAnnotation] = useState(null);

  // Update the initial image dimensions calculation
  // const getInitialImageDimensions = (event, pageElement) => {
  //   const rect = pageElement.getBoundingClientRect();
  //   const defaultWidth = 200; // Default width in pixels
  //   // const defaultHeight = 150; // Default height in pixels
  //   // Create image to get natural dimensions
  //   const img = new Image();
  //   img.src =
  //     "https://res.cloudinary.com/dlm56y4v4/image/upload/v1739505479/loneliness/user_profiles/xy9byljg88e5rxtfuzc5.jpg";

  //   // Calculate aspect ratio based dimensions
  //   const aspectRatio = img.width / img.height;
  //   const defaultHeight = defaultWidth / aspectRatio;
  //   return {
  //     width: defaultWidth / scale,
  //     height: defaultHeight / scale,
  //     x: (event.clientX - rect.left) / scale,
  //     y: (event.clientY - rect.top) / scale,
  //   };
  // };
  const getInitialImageDimensions = (event, pageElement, pageNum) => {
    // const rect = pageElement.getBoundingClientRect();

    // // ✅ Correct Scroll Offset Fix (Ensures accurate positioning)

    // const xPercent = ((event.clientX - rect.left) / rect.width) * 100;
    // const yPercent = ((event.clientY - rect.top) / rect.height) * 100;
    // ✅ Correctly get bounding box of the PDF page
    // ✅ Get bounding box of the clicked PDF page
    // ✅ Get bounding box of the clicked PDF page
    // ✅ Get bounding box of clicked PDF page
    // ✅ Correct reference container
    const pdfContentBox =
      pdfContainerRef.current?.querySelector(".pdf-content-box");
    if (!pdfContentBox) return;

    // ✅ Get scrolling offsets
    const scrollOffsetY = pdfContentBox.scrollTop;
    const scrollOffsetX = pdfContentBox.scrollLeft;

    // ✅ Get bounding rects
    const pageRect = pageElement.getBoundingClientRect();
    const pdfContentBoxRect = pdfContentBox.getBoundingClientRect();

    // ✅ Calculate the total height of all pages above the clicked page
    let totalOffsetAbove = 0;
    const allPages = [...document.querySelectorAll(".pdf-page-container")];

    for (const page of allPages) {
      if (page === pageElement) break;
      totalOffsetAbove +=
        page.offsetHeight +
        parseFloat(window.getComputedStyle(page).marginBottom);
    }

    // ✅ Compute Y relative to the full document
    let yAbsolute = event.clientY + scrollOffsetY - pdfContentBoxRect.top;
    let xAbsolute = event.clientX + scrollOffsetX - pageRect.left;

    // ✅ Ensure accurate Y correction when clicking near the bottom
    const distanceFromBottom = pageRect.bottom - event.clientY;
    console.log("distanceFromBottom", distanceFromBottom);
    const isNearBottom = distanceFromBottom < 700; // Adjust if necessary

    if (isNearBottom) {
      yAbsolute += 15; // 🔥 Tiny padding to prevent shifting upwards
    }

    // ✅ Convert to percentage relative to the page
    const xPercent = (xAbsolute / pageRect.width) * 100;
    const yPercent = ((yAbsolute - totalOffsetAbove) / pageRect.height) * 100;

    return { xPercent, yPercent };
  };

  // Add this helper function to get initial dimensions based on type
  const getDefaultDimensions = (type, scale) => {
    const settings = annotationSettings[type] || {};

    // Use existing settings if available, otherwise use defaults
    switch (type) {
      case "my_text":
      case "signer_text":
        return {
          width: (settings.width || 150) / scale,
          height: (settings.height || 30) / scale,
        };
      case "signer_initials":
        return {
          width: (settings.width || 250) / scale,
          height: (settings.height || 100) / scale,
        };
      case "signer_initials_text":
        return {
          width: (settings.width || 100) / scale,
          height: (settings.height || 100) / scale,
        };
      case "signer_date":
      case "date":
        return {
          width: (settings.width || 150) / scale,
          height: (settings.height || 30) / scale,
        };
      case "signer_checkmark":
      case "checkmark":
        return {
          width: (settings.width || 30) / scale,
          height: (settings.height || 30) / scale,
        };
      case "signer_dropdown":
        return {
          width: (settings.width || 150) / scale,
          height: (settings.height || 30) / scale,
        };
      case "signer_chooseImgStamp":
        return {
          width: (settings.width || 150) / scale,
          height: (settings.height || 150) / scale,
        };
      case "signer_chooseImgDrivingL":
        return {
          width: (settings.width || 350) / scale,
          height: (settings.height || 200) / scale,
        };
      case "signer_chooseImgPassportPhoto":
        return {
          width: (settings.width || 450) / scale,
          height: (settings.height || 300) / scale,
        };
      case "highlight":
        return {
          width: (settings.width || 150) / scale,
          height: (settings.height || 30) / scale,
        };
      default:
        return {
          width: 150 / scale,
          height: 30 / scale,
        };
    }
  };
  const truncateName = (name, maxLength = 5) => {
    return name.length > maxLength
      ? `${name.substring(0, maxLength)}...`
      : name;
  };

  // Add this function to get the appropriate icon and text for each type
  // const getSignerBoxContent = (type) => {
  //   switch (type) {
  //     case "signer_initials":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Signature",
  //       };
  //     case "signer_initials_text":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Initials",
  //       };
  //     case "signer_chooseImgStamp":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Stamp",
  //       };
  //     case "signer_chooseImgDrivingL":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Driving License",
  //       };
  //     case "signer_chooseImgPassportPhoto":
  //       return {
  //         icon: <EditIcon sx={{ fontSize: 20 }} />,
  //         text: "Passport Photo",
  //       };
  //     default:
  //       return null;
  //   }
  // };
  // Add this effect to measure first page height
  useEffect(() => {
    if (pdfImages.length > 0) {
      const img = new Image();
      img.onload = () => {
        setFirstPageHeight(img.height);
      };
      img.src = pdfImages[0];
    }
  }, [pdfImages]);
  // Add this useEffect to automatically select the last added signer
  useEffect(() => {
    if (signers.length > 0) {
      setSelectedSignerId(signers[signers.length - 1]);
      setSelectedSigner(signers[signers.length - 1]);
      setActive("2");
    }
  }, [signers]);
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);

  const [isInteracting, setIsInteracting] = useState(false);
  const handleSignatureComplete = async (signatureData, typeData) => {
    // Guard clause to prevent execution if no click position
    // Convert base64 to file
    setIsSignatureLoading(true); // Start loading
    try {
      const base64Response = await fetch(signatureData);
      const blob = await base64Response.blob();
      const fileObject = new File([blob], "signature.png", {
        type: "image/png",
      });

      // Upload to API
      const postData = {
        image: fileObject,
        user_id: userId,
      };

      const apiData = await postFormData(postData);

      if (!apiData.public_url) {
        toastAlert("error", "Error uploading Files");
        return;
      }

      const ImageUrl = apiData.public_url;

      if (editingAnnotation) {
        // Handle editing existing signature
        const img = new Image();
        img.src = signatureData;

        img.onload = () => {
          setAnnotations((prev) => {
            const updatedAnnotations = { ...prev };
            const { pageNum, index } = editingAnnotation;

            updatedAnnotations[pageNum][index] = {
              ...updatedAnnotations[pageNum][index],
              imageUrl: ImageUrl,
            };

            return updatedAnnotations;
          });

          setEditingAnnotation(null);
          setSignatureModalOpen(false);
          setIsSignatureLoading(false); // Stop loading
        };
      } else {
        if (!lastClickPosition) {
          console.log("No click position available");
          // setIsSignatureLoading(false); // Stop loading
          return;
        }

        const img = new Image();
        img.src = signatureData;

        img.onload = () => {
          const intrinsicWidth = img.width;
          const intrinsicHeight = img.height;
          const widthd = typeData ? 100 : 100;
          const widthdt = typeData ? 400 : 200;

          // Define the desired display width
          const displayWidth = initialsBox ? widthd : widthdt;
          const aspectRatio = intrinsicWidth / intrinsicHeight;
          const displayHeight = displayWidth / aspectRatio;

          // Adjust dimensions based on the current scale
          const adjustedWidth = displayWidth / scale;
          const adjustedHeight = displayHeight / scale;

          setAnnotations((prev) => {
            const pageAnnotations = prev[activePage] || [];
            const loadingIndex = pageAnnotations.findIndex((a) => a.isLoading);

            if (loadingIndex !== -1) {
              const newAnnotations = [...pageAnnotations];
              newAnnotations[loadingIndex] = {
                ...newAnnotations[loadingIndex],
                imageUrl: ImageUrl,
                // width: adjustedWidth,
                // height: adjustedHeight,
                isLoading: false,
                isSignature: true,
              };
              handleAnnotationClick(activePage, loadingIndex, newAnnotations);

              return {
                ...prev,
                [activePage]: newAnnotations,
              };
            }

            return prev;
          });

          // Clear the last click position after using it
          setLastClickPosition(null);
          setSignatureModalOpen(false);
          setIsSignatureLoading(false); // Stop loading
        };
      }
    } catch (error) {
      console.error("Error uploading signature:", error);
      setIsSignatureLoading(false); // Stop loa
      toastAlert("error", "Error uploading signature");
      setAnnotations((prev) => {
        const pageAnnotations = prev[activePage] || [];
        return {
          ...prev,
          [activePage]: pageAnnotations.filter((a) => !a.isLoading),
        };
      });
    }
  };
  const getResizeHandles = (type) => {
    if (type === "signer_text") {
      return {
        topRight: false,
        topLeft: false,
        bottomLeft: false,
        top: false,
        right: false,
        bottom: false,
        left: false,
        bottomRight: true, // Only bottom-right for signer_text
      };
    }

    if (type === "highlight") {
      return {
        topRight: true,
        bottomRight: true,
        bottomLeft: true,
        topLeft: true,
      }; // Full freeform for highlight
    }

    if (shouldLockAspectRatio(type)) {
      return {
        topRight: false,
        bottomRight: true,
        bottomLeft: true,
        topLeft: true,
      }; // Aspect ratio locked types
    }

    // Default case (other types - restricted)
    return {
      topRight: false,
      bottomRight: false,
      bottomLeft: false,
      topLeft: false,
    };
  };

  const shouldLockAspectRatio = (type) => {
    const typesWithLockedAspectRatio = [
      "stamp",
      // "highlight",
      "my_signature",
      "my_initials",
      "signer_initials",
      "signer_initials_text",
      "signer_chooseImgStamp",
      "signer_chooseImgDrivingL",
      "signer_chooseImgPassportPhoto",
    ];
    return typesWithLockedAspectRatio.includes(type);
  };
  // 1. Add a new state for tracking the annotation being edited
  const [editingAnnotation, setEditingAnnotation] = useState(null);

  // 2. Add handler for editing signature
  const handleEditSignature = (pageNum, index, annot) => {
    setEditingAnnotation({ pageNum, index, annot });
    setInitialBox(annot.type === "my_initials");
    setSignatureModalOpen(true);
  };

  // 3. Add handler for editing stamp
  const handleEditStamp = (pageNum, index, annot) => {
    setEditingAnnotation({ pageNum, index, annot });
    stampInputRef.current.click();
  };
  const [lastClickPosition, setLastClickPosition] = useState(null);
  const [loadingPositions, setLoadingPositions] = useState({});
  // Check if the current annotationType is in the array
  const calculateTextWidth = (
    text,
    fontSize = 16,
    fontFamily = "Helvetica"
  ) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    ctx.font = `${fontSize}px ${fontFamily}`;

    const textWidth = Math.ceil(ctx.measureText(text).width);

    const padding = 10; // Minimum, adjust if you want some breathing room
    return textWidth + padding; // Remove excessive padding
  };

  const handlePdfClickPrevCorrect = (event) => {
    if (!isAnnotating || isDragging || isResizing || isInteracting) return;

    const pageElement = event.target.closest(".pdf-page-container");
    if (!pageElement) return;
    // Get page number from element ID
    const pageNum = parseInt(pageElement.id.split("-")[1]);

    const isAnnotationClick =
      event.target.closest(".annotation") ||
      event.target.closest(".react-rnd-resizable-handle") ||
      event.target.closest(".MuiIconButton-root");

    if (isAnnotationClick) return;

    const { width, height, x, y } = getInitialImageDimensions(
      event,
      pageElement,
      pageNum
    );
    // Get saved settings for the current annotation type
    const settings = annotationSettings[annotationType] || {};

    const baseAnnotation = {
      id: Date.now(),
      x,
      y,
      page_no: pageNum,
      type: annotationType,
      width: (settings.width || width) / scale,
      height: (settings.height || height) / scale,
    };

    if (annotationType === "signer_date" || annotationType === "date") {
      const currentDate = new Date();
      const defaultFormat = "MMM dd, yyyy";
      try {
        const formattedDate = format(
          new Date(),
          settings.dateFormat || "MMM dd, yyyy"
        );
        // const newAnnotation = {
        //   id: Date.now(),
        //   x,
        //   y,
        //   text: formattedDate,
        //   type: "date",
        //   fontSize: 14,
        //   fontFamily: "Helvetica",
        //   format: [],
        //   dateFormat: defaultFormat,
        //   width: 150 / scale,
        //   height: 30 / scale,
        //   date: currentDate,
        // };
        const calculatedWidth = calculateTextWidth(
          formattedDate,
          settings.fontSize || 16
        );
        const newAnnotation = {
          id: Date.now(),
          x,
          y,
          // text: formattedDate,
          text: format(new Date(), settings.dateFormat || "MMM dd, yyyy"),
          type: annotationType,
          // fontSize: 14,
          fontSize: settings.fontSize || 16,
          fontFamily: "Helvetica",
          format: [],
          // dateFormat: defaultFormat,
          dateFormat: settings.dateFormat || defaultFormat,
          width: calculatedWidth / scale,
          height: 30 / scale,
          signerId:
            annotationType === "signer_date" ? selectedSigner?.signer_id : null,
          page_no: pageNum, //
          date: currentDate,
          backgroundColor:
            annotationType === "signer_date"
              ? `${selectedSigner?.color}` // Add 20 for opacity
              : "rgba(0, 17, 18, 0.25)",
          signerColor:
            annotationType === "signer_date"
              ? `${selectedSigner?.color}` // Add 20 for opacity
              : "rgba(0, 17, 18, 0.25)",
          borderColor:
            annotationType === "signer_date"
              ? selectedSigner?.color
              : "rgba(0, 0, 0, 0.23)",
        };

        setAnnotations((prev) => {
          const updatedAnnotations = {
            ...prev,
            [activePage]: [...(prev[activePage] || []), newAnnotation],
          };

          // Get the index of the newly added annotation
          const newIndex = updatedAnnotations[activePage].length - 1;

          // Set the selected annotation immediately after creation
          setSelectedAnnotation({
            ...newAnnotation,
            pageNum: activePage,
            index: newIndex,
          });

          // Set the active annotation ID
          setActiveAnnotationId(`${activePage}-${newIndex}`);

          return updatedAnnotations;
        });
      } catch (error) {
        console.error("Error creating date annotation:", error);
      }
      return;
    }
    // Add this condition for stamp type
    if (annotationType === "stamp") {
      const clickPosition = { x, y };
      setPageNoClicked(pageNum);
      setStampClickPosition(clickPosition); // Store click position
      const input = stampInputRef.current;
      input.click();
      return;
    }
    // In App.js
    if (annotationType === "checkmark") {
      const newAnnotation = {
        id: Date.now(),
        x,
        y,
        type: "checkmark",
        checked: true,
        page_no: pageNum, //
        width: 30 / scale,
        height: 30 / scale,
      };

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        return updatedAnnotations;
      });
      return;
    }
    if (annotationType === "signer_checkmark") {
      const newAnnotation = {
        id: Date.now(),
        x,
        y,
        type: "signer_checkmark",

        backgroundColor: `${selectedSigner?.color}`, // Add 20 for opacity
        signerColor: `${selectedSigner?.color}`, // Add 20 for opacity

        borderColor: selectedSigner?.color,
        page_no: pageNum, //
        checked: false,
        signerId: selectedSigner?.signer_id,

        width: 30 / scale,
        height: 30 / scale,
        isRequired: false,
      };

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        return updatedAnnotations;
      });
      return;
    }
    // In App.js, add to handlePdfClick function
    if (annotationType === "highlight") {
      const newAnnotation = {
        id: Date.now(),
        x,
        y,
        type: "highlight",
        width: 120 / scale,
        page_no: pageNum, //
        height: 25 / scale,
        backgroundColor: "rgba(255, 255, 0, 0.3)", // Light yellow with opacity
      };
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        // setAnnotations((prev) => {
        //   const updatedAnnotations = {
        //     ...prev,
        //     [activePage]: [...(prev[activePage] || []), newAnnotation],
        //   };
        //   const newIndex = updatedAnnotations[activePage].length - 1;
        //   setActiveAnnotationId(`${activePage}-${newIndex}`);

        //   // Set the selected annotation immediately after creation
        //   setSelectedAnnotation({
        //     ...newAnnotation,
        //     pageNum: activePage,
        //     index: newIndex,
        //   });

        return updatedAnnotations;
      });
      return;
    }
    // if (annotationType === "my_signature" || annotationType === "my_initials") {
    //   setLastClickPosition({ x, y });
    //   setInitialBox(annotationType === "my_signature" ? false : true);
    //   setSignatureModalOpen(true);

    //   return;
    // }
    if (annotationType === "my_signature" || annotationType === "my_initials") {
      const loadingId = `${pageNum}-${Date.now()}`;

      // Create temporary loading annotation
      const tempAnnotation = {
        id: Date.now(),
        x,
        y,
        type: annotationType,
        width: annotationType === "my_signature" ? 250 : 100,
        height: annotationType === "my_signature" ? 100 : 80,
        isLoading: true,
        page_no: pageNum,
      };

      // Add the temporary annotation
      setAnnotations((prev) => ({
        ...prev,
        [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
      }));
      setLastClickPosition({ x, y });
      setPageNoClicked(pageNum);
      setInitialBox(annotationType.includes("initials"));
      setSignatureModalOpen(true);
      // Store the loading position info
      setLoadingPositions((prev) => ({
        ...prev,
        [loadingId]: tempAnnotation,
      }));
      return;
    }
    // Inside handlePdfClick function where it creates new annotation

    let annotationText = "";

    if (annotationType === "my_text") {
      annotationText = ""; // Empty text for these types
      const savedSettings = annotationSettings.my_text;

      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        x,
        y,
        text: "",
        imageUrl: null,
        page_no: pageNum, //
        type: annotationType,
        // fontSize: 14,
        // fontFamily: "Helvetica",
        // format: [],
        fontSize: settings.fontSize || 16,
        fontFamily: settings.fontFamily || "Helvetica",
        format: settings.format || [],
        width: 150 / scale,
        height: 30 / scale,
        // width: savedSettings.width || 150, // Use saved width
        // width: (textFieldMetrics.width || 120) / scale,
        // height: (textFieldMetrics.height || 30) / scale,
        backgroundColor:
          annotationType === "signer_text"
            ? `${selectedSigner?.color}20` // Add 20 for opacity
            : "rgba(0, 247, 255, 0.25)",
        borderColor:
          annotationType === "signer_text"
            ? selectedSigner?.color
            : "rgba(0, 0, 0, 0.23)",
      };

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        setTimeout(() => {
          const annotationIndex = updatedAnnotations[activePage].length - 1;
          const element =
            annotationRefs.current[`${activePage}-${annotationIndex}`];
          if (element) {
            element.focus();
            if (cursorRef.current) {
              cursorRef.current.style.top = `${event.clientY + 50}px`;
              cursorRef.current.style.left = `${event.clientX}px`;
              cursorRef.current.style.display = "none";
              setTimeout(() => {
                if (cursorRef.current) {
                  cursorRef.current.style.display = "block";
                }
              }, 100);
            }
          }
        }, 0);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_text") {
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        x,
        y,
        text: "",
        imageUrl: null,
        type: annotationType,
        fontSize: settings.fontSize || 16,
        fontFamily: settings.fontFamily || "Helvetica",
        format: settings.format || [],
        // fontSize: 14,
        // fontFamily: "Helvetica",
        // format: [],
        // width: 150 / scale,
        page_no: pageNum, //
        // height: 30 / scale,
        width: (textFieldMetrics.width || 120) / scale,
        height: (textFieldMetrics.height || 30) / scale,
        backgroundColor: `${selectedSigner?.color}`,
        signerColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        signerId: selectedSigner?.signer_id, // Add signer ID
        signerName: selectedSigner?.name, // Optional: add signer name for reference
        // isRequired: false,
        isRequired: globalIsRequired,
      };
      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_dropdown") {
      const newAnnotation = {
        id: Date.now(),
        x,
        y,
        type: annotationType,
        width: 150 / scale,
        height: 30 / scale,
        page_no: pageNum, //
        options: [],
        selectedOption: "",
        signerId: selectedSigner?.signer_id,
        signerColor: selectedSigner?.color,
        signerName: selectedSigner?.name,
        backgroundColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        // isRequired: false,
        isRequired: globalIsRequired,
      };

      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }

    if (
      [
        "signer_initials",
        "signer_initials_text",
        "signer_chooseImgStamp",
        "signer_chooseImgDrivingL",
        "signer_chooseImgPassportPhoto",
      ].includes(annotationType)
    ) {
      const dimensions = getDefaultDimensions(annotationType, scale);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        x,
        y,
        type: annotationType,
        width: dimensions.width,
        height: dimensions.height,
        signerId: selectedSigner?.signer_id,
        page_no: pageNum, //
        signerColor: selectedSigner?.color,
        signerName: selectedSigner?.name,
        imageUrl: null, // Will be filled when user adds content
        backgroundColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        // isRequired: settings.isRequired || false,
        isRequired: globalIsRequired,
      };

      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
  };
  const handlePdfClick = (event) => {
    if (!isAnnotating || isDragging || isResizing || isInteracting) return;

    const pageElement = event.target.closest(".pdf-page-container");
    if (!pageElement) return;
    // Get page number from element ID
    const pageNum = parseInt(pageElement.id.split("-")[1]);

    const isAnnotationClick =
      event.target.closest(".annotation") ||
      event.target.closest(".react-rnd-resizable-handle") ||
      event.target.closest(".MuiIconButton-root");

    if (isAnnotationClick) return;

    // // Get saved settings for the current annotation type
    const settings = annotationSettings[annotationType] || {};

    // scroll

    // end
    const { xPercent, yPercent } = getInitialImageDimensions(
      event,
      pageElement
    );
    const pageWidth = pageElement.getBoundingClientRect().width;
    const pageHeight = pageElement.getBoundingClientRect().height;

    console.log("pdf width", pageWidth);

    const fontSize = settings.fontSize || 16;
    // const fontSizePt = settings.fontSize || 12; // Default in pt
    // const fontSizePx = fontSizePt * (96 / 72); // To render in browser
    // console.log("fontsize", fontSizePt);
    // console.log("fontsizePCX", fontSizePx);

    // Apply this `fontSizePx` in the RND/TextField

    const defaultWidth = 150; // Default text box width in pixels
    const defaultHeight = 30; // Default height in pixels
    const pageRect = pageElement.getBoundingClientRect();
    let baseAnnotation = {
      id: Date.now(),
      x: xPercent,
      y: yPercent,
      page_no: pageNum,
      type: annotationType,
      width: settings.width / scale,
      height: settings.height / scale,
    };
    if (annotationType === "my_text") {
      const calculatedWidth = calculateTextWidth(
        "Text ....",
        settings.fontSize || 16,
        settings.fontFamily || "Helvetica"
      );
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        type: "my_text",

        // x: xPercent,
        // y: yPercent,
        width: (calculatedWidth / pageRect.width) * 100,
        height: (20 / pageRect.height) * 100,
        text: "",
        fontSize, // Save font size directly
        fontFamily: settings.fontFamily || "Helvetica",
        format: settings.format || [],
        backgroundColor: "rgba(0, 247, 255, 0.25)",
        borderColor: "rgba(0, 0, 0, 0.23)",
      };

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        setTimeout(() => {
          const annotationIndex = updatedAnnotations[activePage].length - 1;
          const element =
            annotationRefs.current[`${activePage}-${annotationIndex}`];
          if (element) {
            element.focus();
            if (cursorRef.current) {
              cursorRef.current.style.top = `${event.clientY + 50}px`;
              cursorRef.current.style.left = `${event.clientX}px`;
              cursorRef.current.style.display = "none";
              setTimeout(() => {
                if (cursorRef.current) {
                  cursorRef.current.style.display = "block";
                }
              }, 100);
            }
          }
        }, 0);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_text") {
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        text: "",
        imageUrl: null,
        type: annotationType,
        fontSize,
        fontFamily: settings.fontFamily || "Helvetica",
        format: settings.format || [],
        // fontSize: 14,
        // fontFamily: "Helvetica",
        // format: [],
        // width: 150 / scale,

        // height: 30 / scale,
        // width: (textFieldMetrics.width || 120) / scale,
        // height: (textFieldMetrics.height || 30) / scale,
        width: (150 / pageRect.width) * 100,
        height: (20 / pageRect.height) * 100,
        backgroundColor: `${selectedSigner?.color}`,
        signerColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        signerId: selectedSigner?.signer_id, // Add signer ID
        signerName: selectedSigner?.name, // Optional: add signer name for reference
        // isRequired: false,
        isRequired: globalIsRequired,
      };
      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_dropdown") {
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: 150 / scale,
        // height: 30 / scale,
        width: (150 / pageRect.width) * 100,
        height: (30 / pageRect.height) * 100,
        page_no: pageNum, //
        options: [],
        selectedOption: "",
        signerId: selectedSigner?.signer_id,
        signerColor: selectedSigner?.color,
        signerName: selectedSigner?.name,
        backgroundColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        // isRequired: false,
        isRequired: globalIsRequired,
      };

      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
    if (annotationType === "signer_date" || annotationType === "date") {
      const currentDate = new Date();
      console.log("sin er date", annotationType);
      const defaultFormat = "MMM dd, yyyy";
      try {
        const formattedDate = format(
          new Date(),
          settings.dateFormat || "MMM dd, yyyy"
        );
        // const newAnnotation = {
        //   id: Date.now(),
        //   x,
        //   y,
        //   text: formattedDate,
        //   type: "date",
        //   fontSize: 14,
        //   fontFamily: "Helvetica",
        //   format: [],
        //   dateFormat: defaultFormat,
        //   width: 150 / scale,
        //   height: 30 / scale,
        //   date: currentDate,
        // };
        const calculatedWidth = calculateTextWidth(
          `${formattedDate}T`,
          settings.fontSize || 16
        );
        const newAnnotation = {
          ...baseAnnotation,
          id: Date.now(),
          // x: xPercent,
          // y: yPercent,
          // text: formattedDate,
          text: format(new Date(), settings.dateFormat || "MMM dd, yyyy"),
          type: annotationType,
          // fontSize: 14,
          fontSize: settings.fontSize || 16,
          fontFamily: "Helvetica",
          format: [],
          // dateFormat: defaultFormat,
          dateFormat: settings.dateFormat || defaultFormat,
          // width: calculatedWidth,
          // height: 30,
          width: (calculatedWidth / pageRect.width) * 100,
          height: (30 / pageRect.height) * 100,
          signerId:
            annotationType === "signer_date" ? selectedSigner?.signer_id : null,
          page_no: pageNum, //
          date: currentDate,
          backgroundColor:
            annotationType === "signer_date"
              ? `${selectedSigner?.color}` // Add 20 for opacity
              : "rgba(0, 17, 18, 0.25)",
          signerColor:
            annotationType === "signer_date"
              ? `${selectedSigner?.color}` // Add 20 for opacity
              : "rgba(0, 17, 18, 0.25)",
          borderColor:
            annotationType === "signer_date"
              ? selectedSigner?.color
              : "rgba(0, 0, 0, 0.23)",
        };
        console.log("newAnnotation", newAnnotation);
        setAnnotations((prev) => {
          const updatedAnnotations = {
            ...prev,
            [activePage]: [...(prev[activePage] || []), newAnnotation],
          };

          // Get the index of the newly added annotation
          const newIndex = updatedAnnotations[activePage].length - 1;

          // Set the selected annotation immediately after creation
          setSelectedAnnotation({
            ...newAnnotation,
            pageNum: activePage,
            index: newIndex,
          });

          // Set the active annotation ID
          setActiveAnnotationId(`${activePage}-${newIndex}`);

          return updatedAnnotations;
        });
      } catch (error) {
        console.error("Error creating date annotation:", error);
      }
      return;
    }
    // Add this condition for stamp type
    if (annotationType === "stamp") {
      const clickPosition = {
        x: xPercent,
        y: yPercent,
        width: (150 / pageRect.width) * 100,
        height: (150 / pageRect.height) * 100,
      };
      setPageNoClicked(pageNum);
      setStampClickPosition(clickPosition); // Store click position
      const input = stampInputRef.current;
      input.click();
      return;
    }
    // In App.js
    if (annotationType === "checkmark") {
      // const newAnnotation = {
      //   ...baseAnnotation,
      //   id: Date.now(),
      //   // x,
      //   // y,
      //   type: "checkmark",
      //   checked: true,
      //   page_no: pageNum, //
      //   width: (250 / pageRect.width) * 100,
      //   height: (250 / pageRect.height) * 100,
      // };
      const defaultSize = 34; // or whatever fits your design
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        type: "checkmark",
        checked: true, // default unchecked
        width: (defaultSize / pageWidth) * 100,
        height: (defaultSize / pageHeight) * 100,
      };
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        return updatedAnnotations;
      });
      return;
    }
    if (annotationType === "signer_checkmark") {
      const defaultSize = 34; // or whatever fits your design

      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: "signer_checkmark",

        backgroundColor: `${selectedSigner?.color}`, // Add 20 for opacity
        signerColor: `${selectedSigner?.color}`, // Add 20 for opacity

        borderColor: selectedSigner?.color,
        page_no: pageNum, //
        checked: false,
        signerId: selectedSigner?.signer_id,

        width: (defaultSize / pageWidth) * 100,
        height: (defaultSize / pageHeight) * 100,
        isRequired: false,
      };

      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        return updatedAnnotations;
      });
      return;
    }
    // In App.js, add to handlePdfClick function
    if (annotationType === "highlight") {
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: "highlight",
        width: (120 / pageRect.width) * 100,
        height: (25 / pageRect.height) * 100,
        // width: 120 / scale,
        page_no: pageNum, //
        // height: 25 / scale,
        backgroundColor: "rgba(255, 255, 0, 0.3)", // Light yellow with opacity
      };
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        // setAnnotations((prev) => {
        //   const updatedAnnotations = {
        //     ...prev,
        //     [activePage]: [...(prev[activePage] || []), newAnnotation],
        //   };
        //   const newIndex = updatedAnnotations[activePage].length - 1;
        //   setActiveAnnotationId(`${activePage}-${newIndex}`);

        //   // Set the selected annotation immediately after creation
        //   setSelectedAnnotation({
        //     ...newAnnotation,
        //     pageNum: activePage,
        //     index: newIndex,
        //   });

        return updatedAnnotations;
      });
      return;
    }

    if (annotationType === "my_signature") {
      const loadingId = `${pageNum}-${Date.now()}`;

      // Create temporary loading annotation
      const tempAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: annotationType === "my_signature" ? 250 : 100,
        // height: annotationType === "my_signature" ? 100 : 80,
        width: (250 / pageRect.width) * 100,
        height: (100 / pageRect.height) * 100,
        isLoading: true,
        page_no: pageNum,
      };

      // Add the temporary annotation
      setAnnotations((prev) => ({
        ...prev,
        [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
      }));
      setLastClickPosition({ x: xPercent, y: yPercent });
      setPageNoClicked(pageNum);
      setInitialBox(annotationType.includes("initials"));
      setSignatureModalOpen(true);
      // Store the loading position info
      setLoadingPositions((prev) => ({
        ...prev,
        [loadingId]: tempAnnotation,
      }));
      return;
    }
    if (annotationType === "my_initials") {
      const loadingId = `${pageNum}-${Date.now()}`;

      // Create temporary loading annotation
      const tempAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: annotationType === "my_signature" ? 250 : 100,
        // height: annotationType === "my_signature" ? 100 : 80,
        width: (100 / pageRect.width) * 100,
        height: (100 / pageRect.height) * 100,
        isLoading: true,
        page_no: pageNum,
      };

      // Add the temporary annotation
      setAnnotations((prev) => ({
        ...prev,
        [pageNum]: [...(prev[pageNum] || []), tempAnnotation],
      }));
      setLastClickPosition({ x: xPercent, y: yPercent });
      setPageNoClicked(pageNum);
      setInitialBox(annotationType.includes("initials"));
      setSignatureModalOpen(true);
      // Store the loading position info
      setLoadingPositions((prev) => ({
        ...prev,
        [loadingId]: tempAnnotation,
      }));
      return;
    }
    if (
      [
        "signer_initials",
        "signer_initials_text",
        "signer_chooseImgStamp",
        "signer_chooseImgDrivingL",
        "signer_chooseImgPassportPhoto",
      ].includes(annotationType)
    ) {
      const dimensions = getDefaultDimensions(annotationType, scale);
      const newAnnotation = {
        ...baseAnnotation,
        id: Date.now(),
        // x,
        // y,
        type: annotationType,
        // width: dimensions.width,
        // height: dimensions.height,
        width: (dimensions.width / pageRect.width) * 100,
        height: (dimensions.height / pageRect.height) * 100,
        signerId: selectedSigner?.signer_id,
        page_no: pageNum, //
        signerColor: selectedSigner?.color,
        signerName: selectedSigner?.name,
        imageUrl: null, // Will be filled when user adds content
        backgroundColor: `${selectedSigner?.color}`,
        borderColor: selectedSigner?.color,
        // isRequired: settings.isRequired || false,
        isRequired: globalIsRequired,
      };

      // setAnnotations((prev) => ({
      //   ...prev,
      //   [activePage]: [...(prev[activePage] || []), newAnnotation],
      // }));
      setAnnotations((prev) => {
        const updatedAnnotations = {
          ...prev,
          [activePage]: [...(prev[activePage] || []), newAnnotation],
        };

        // Get the index of the newly added annotation
        const newIndex = updatedAnnotations[activePage].length - 1;

        // Set the selected annotation immediately after creation
        setSelectedAnnotation({
          ...newAnnotation,
          pageNum: activePage,
          index: newIndex,
        });

        // Set the active annotation ID
        setActiveAnnotationId(`${activePage}-${newIndex}`);
        setActiveAnnotation(`${activePage}-${newIndex}`);

        return updatedAnnotations;
      });
    }
  };
  // Inside App.js, modify the handlePdfClick function

  const handleAnnotationClick = (pageNum, index, annotation) => {
    console.log("clicked texct ");
    console.log("clicked texct ", annotation);

    const annotationId = `${pageNum}-${index}`;
    setActiveAnnotationId(annotationId);
    setActiveAnnotation(annotationId);
    setSelectedAnnotation({
      ...annotation,
      pageNum,
      index,
    });
    // Set focused annotation
    setFocusedAnnotation(annotationId);
  };

  // Add this new state at the top of your EsignSetupView component

  // Modify handleAnnotationTextChange
  const handleAnnotationTextChange1 = (e, pageNum, index) => {
    if (selectedAnnotation.type === "my_text") {
      const newText = e.target.value;
      const inputEl = annotationRefs.current[`${pageNum}-${index}`];
      if (!inputEl) return;

      const annotationId = `${pageNum}-${index}`;
      const currentAnnotation = annotations[pageNum][index];
      const currentWidth = currentAnnotation.width * scale;

      // Create temporary span for text measurement
      const span = document.createElement("span");
      const computedStyle = window.getComputedStyle(inputEl);
      span.style.cssText = `
        visibility: hidden;
        position: fixed;
        font-family: ${computedStyle.fontFamily};
        font-size: ${computedStyle.fontSize};
        font-weight: ${computedStyle.fontWeight};
        font-style: ${computedStyle.fontStyle};
        letter-spacing: ${computedStyle.letterSpacing};
        white-space: pre;
        padding: ${computedStyle.padding};
    `;
      span.innerText = newText || " ";
      document.body.appendChild(span);

      const textWidth = Math.ceil(span.getBoundingClientRect().width);
      document.body.removeChild(span);

      // Calculate width for **one character** (like "M" which is usually widest)
      span.innerText = "W"; // This gives us a realistic "minimum" single character width
      document.body.appendChild(span);
      const singleCharWidth = Math.ceil(span.getBoundingClientRect().width);
      document.body.removeChild(span);

      const padding = 16;
      const buffer = 2;

      // This replaces the hardcoded 150px minimum width:
      const dynamicMinWidth = Math.max(singleCharWidth + padding + buffer, 50);

      // Calculate required width for text
      const requiredWidth = Math.ceil((textWidth + padding + buffer) / 10) * 10;

      // Check if this field has been filled before
      const hasBeenFilled = textFieldHistory[annotationId]?.hasBeenFilled;
      const maxReachedWidth =
        textFieldHistory[annotationId]?.maxWidth || dynamicMinWidth;

      // Determine if field is being filled now
      const isFillingNow = requiredWidth > maxReachedWidth;

      // Update field history
      setTextFieldHistory((prev) => ({
        ...prev,
        [annotationId]: {
          hasBeenFilled: hasBeenFilled || isFillingNow,
          maxWidth: Math.max(maxReachedWidth, requiredWidth),
        },
      }));

      // Calculate new width based on state
      let newWidth;
      if (!hasBeenFilled) {
        newWidth = Math.max(dynamicMinWidth, requiredWidth);
      } else {
        // Allow shrinking down to `dynamicMinWidth` (single character width + padding)
        newWidth = Math.max(dynamicMinWidth, requiredWidth);
      }

      const scaledWidth = newWidth / scale;

      if (newWidth !== annotationSettings.my_text.width) {
        setTextFieldMetrics((prev) => ({
          ...prev,
          width: newWidth,
        }));

        setAnnotationSettings((prev) => ({
          ...prev,
          my_text: {
            ...prev.my_text,
            width: newWidth,
          },
        }));
      }

      // Update annotation
      setAnnotations((prev) => {
        const pageAnns = [...(prev[pageNum] || [])];
        pageAnns[index] = {
          ...pageAnns[index],
          text: newText,
          width: scaledWidth,
        };
        return { ...prev, [pageNum]: pageAnns };
      });
    }
  };
  const handleAnnotationTextChange = (e, pageNum, index) => {
    if (selectedAnnotation.type === "my_text") {
      const newText = e.target.value;
      const inputEl = annotationRefs.current[`${pageNum}-${index}`];
      if (!inputEl) return;

      const currentAnnotation = annotations[pageNum][index];
      const fontSizePx = currentAnnotation.fontSize || 16;

      // ✅ Text measurement (core logic)
      const span = document.createElement("span");
      const computedStyle = window.getComputedStyle(inputEl);
      span.style.cssText = `
        visibility: hidden;
        position: fixed;
        font-family: ${computedStyle.fontFamily};
        font-size: ${fontSizePx}px;
        font-weight: ${computedStyle.fontWeight};
        font-style: ${computedStyle.fontStyle};
        letter-spacing: ${computedStyle.letterSpacing};
        white-space: pre;
        padding: 0;
    `;
      span.innerText = newText || " ";
      document.body.appendChild(span);

      const textWidthPx = Math.ceil(span.getBoundingClientRect().width);
      document.body.removeChild(span);

      // ✅ Page size (to convert px → %)
      const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!pageElement) return;
      const pageWidthPx = pageElement.offsetWidth;

      // ✅ Define a buffer (you can tweak this based on design needs)
      const bufferPx = 20; // extra breathing space on right side (like Docusign)

      // ✅ Total box width in px (text width + buffer)
      const boxWidthPx = textWidthPx + bufferPx;

      // ✅ Minimum width (in case user deletes all text, box should not collapse too small)
      const minWidthPx = 50;

      // ✅ Final width to store (in px)
      const finalWidthPx = Math.max(boxWidthPx, minWidthPx);

      // ✅ Convert to % for storing in annotation (since your positions are % based)
      const newWidthPercent = (finalWidthPx / pageWidthPx) * 100;
      // ✅ Prevent Text from Moving Up (Height Restriction)

      // ✅ Update annotation (main state update)
      setAnnotations((prev) => {
        const pageAnnotations = [...(prev[pageNum] || [])];
        pageAnnotations[index] = {
          ...pageAnnotations[index],
          text: newText,
          width: newWidthPercent, // save in %
        };
        return { ...prev, [pageNum]: pageAnnotations };
      });

      // ✅ Update live metrics for UI (this stays in px)
      setTextFieldMetrics((prev) => ({
        ...prev,
        width: finalWidthPx,
      }));

      // ✅ Optional: If you want to preset this for future fields (like default size for new my_text)
      setAnnotationSettings((prev) => ({
        ...prev,
        my_text: {
          ...prev.my_text,
          width: finalWidthPx, // next new field gets this default width
        },
      }));
    }
  };

  const [isDeleting, setIsDeleting] = useState(false);
  // Handler to delete an annotation
  const handleDeleteAnnotation = (pageNum, index) => {
    setIsDeleting(true);
    const annotationElement = document.querySelector(
      `[data-annot-id="${pageNum}-${annotations[pageNum][index].id}"]`
    );
    if (annotationElement) {
      annotationElement.style.transition = "none";
    }

    setAnnotations((prev) => ({
      ...prev,
      [pageNum]: Array.isArray(prev[pageNum]) ? prev[pageNum].filter((_, i) => i !== index) : [],
    }));
    // setAnnotations((prev) => ({
    //   ...prev,
    //   [pageNum]: prev[pageNum].filter((_, i) => i !== index),
    // }));
  };

  // Memoize render image function
  const renderImage = useCallback((image, index, isMainView = true) => {
    return (
      <img
        src={image}
        alt={`Page ${index + 1}`}
        className={isMainView ? "pdf-image" : "thumbnail-image"}
        loading="lazy"
      />
    );
  }, []);
  //  //correct
  const handleUpdateAnnotation1 = (updatedProps) => {
    if (!selectedAnnotation) return;

    const { pageNum, index } = selectedAnnotation;
    const currentAnnotation = annotations[pageNum][index];

    const type = currentAnnotation.type;

    // Merge current annotation with updated properties
    let mergedAnnotation = {
      ...currentAnnotation,
      ...updatedProps,
    };

    if (
      type === "my_text" ||
      type === "signer_text" ||
      type === "date" ||
      type === "signer_date"
    ) {
      const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!pageElement) return;

      const pageWidth = pageElement.offsetWidth;
      const pageHeight = pageElement.offsetHeight;

      // 1️⃣ Measure text using offscreen span
      const tempSpan = document.createElement("span");
      tempSpan.style.visibility = "hidden";
      tempSpan.style.position = "absolute";
      tempSpan.style.whiteSpace = "pre";

      const fontSize =
        mergedAnnotation.fontSize || currentAnnotation.fontSize || 16;
      const fontFamily =
        mergedAnnotation.fontFamily ||
        currentAnnotation.fontFamily ||
        "Helvetica";
      const fontWeight = mergedAnnotation.format?.includes("bold")
        ? "bold"
        : "normal";
      const fontStyle = mergedAnnotation.format?.includes("italic")
        ? "italic"
        : "normal";
      const letterSpacing = mergedAnnotation.letterSpacing || "normal";

      tempSpan.style.fontSize = `${fontSize}px`;
      tempSpan.style.fontFamily = fontFamily;
      tempSpan.style.fontWeight = fontWeight;
      tempSpan.style.fontStyle = fontStyle;
      tempSpan.style.letterSpacing = letterSpacing;

      tempSpan.innerText = mergedAnnotation.text || "";

      document.body.appendChild(tempSpan);

      const measuredWidth = tempSpan.getBoundingClientRect().width;
      const measuredHeight = tempSpan.getBoundingClientRect().height;

      document.body.removeChild(tempSpan);

      // 2️⃣ Padding and buffer (keep same as your TextField container)
      const padding = 8;
      const buffer = 2;

      const finalWidthPx = measuredWidth + padding + buffer;
      const finalHeightPx = measuredHeight + padding; // Add padding only vertically

      // 3️⃣ Convert to percentage (your positioning system uses percentages)
      const newWidthPercent = (finalWidthPx / pageWidth) * 100;
      const newHeightPercent = (finalHeightPx / pageHeight) * 100;

      // 4️⃣ Fix Baseline - Adjust Y to grow text upwards
      const oldHeightPx = (currentAnnotation.height / 100) * pageHeight;
      const heightDiffPx = finalHeightPx - oldHeightPx;

      const oldYPercent = currentAnnotation.y;
      const heightDiffPercent = (heightDiffPx / pageHeight) * 100;

      const newYPercent = oldYPercent - heightDiffPercent;

      // 5️⃣ Update annotation size and Y position (baseline fixed)
      mergedAnnotation.width = newWidthPercent;
      mergedAnnotation.height = newHeightPercent;
      mergedAnnotation.y = newYPercent;
    }

    // ✅ Update annotations state
    setAnnotations((prevAnnotations) => {
      const pageAnnotations = [...(prevAnnotations[pageNum] || [])];
      pageAnnotations[index] = mergedAnnotation;

      return {
        ...prevAnnotations,
        [pageNum]: pageAnnotations,
      };
    });

    // ✅ Sync updated styles back to annotationSettings (optional)
    setAnnotationSettings((prevSettings) => ({
      ...prevSettings,
      [selectedAnnotation.type]: {
        ...prevSettings[selectedAnnotation.type],
        ...updatedProps,
      },
    }));

    // ✅ Handle global `isRequired` if changed
    if (updatedProps.isRequired !== undefined) {
      setGlobalIsRequired(updatedProps.isRequired);
    }
  };
  // signer text issue test
  const handleUpdateAnnotationook = (updatedProps) => {
    if (!selectedAnnotation) return;

    const { pageNum, index } = selectedAnnotation;
    const currentAnnotation = annotations[pageNum][index];

    const type = currentAnnotation.type;

    // Merge current annotation with updated properties
    let mergedAnnotation = {
      ...currentAnnotation,
      ...updatedProps,
    };

    if (
      type === "my_text" ||
      type === "signer_text" ||
      type === "date" ||
      type === "signer_date"
    ) {
      const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!pageElement) return;

      const pageWidth = pageElement.offsetWidth;
      const pageHeight = pageElement.offsetHeight;

      // 1️⃣ Create offscreen span for accurate measurement
      const tempSpan = document.createElement("span");
      tempSpan.style.visibility = "hidden";
      tempSpan.style.position = "absolute";
      tempSpan.style.whiteSpace = "pre";

      const fontSize =
        mergedAnnotation.fontSize || currentAnnotation.fontSize || 16;
      const fontFamily =
        mergedAnnotation.fontFamily ||
        currentAnnotation.fontFamily ||
        "Helvetica";
      const fontWeight = mergedAnnotation.format?.includes("bold")
        ? "bold"
        : "normal";
      const fontStyle = mergedAnnotation.format?.includes("italic")
        ? "italic"
        : "normal";
      const letterSpacing = mergedAnnotation.letterSpacing || "normal";

      tempSpan.style.fontSize = `${fontSize}px`;
      tempSpan.style.fontFamily = fontFamily;
      tempSpan.style.fontWeight = fontWeight;
      tempSpan.style.fontStyle = fontStyle;
      tempSpan.style.letterSpacing = letterSpacing;

      // When text is empty, use placeholder "Text" to calculate realistic height
      const textToMeasure = mergedAnnotation.text || "Text";
      tempSpan.innerText = textToMeasure;

      document.body.appendChild(tempSpan);

      const measuredWidth = tempSpan.getBoundingClientRect().width;
      const measuredHeight = tempSpan.getBoundingClientRect().height;

      document.body.removeChild(tempSpan);

      // 2️⃣ Consistent padding (same as your MUI TextField)
      const paddingX = 8; // Horizontal padding (left+right)
      const paddingY = 6; // Vertical padding (top+bottom)

      const finalWidthPx = measuredWidth + paddingX * 2;
      const finalHeightPx = measuredHeight + paddingY;

      // 3️⃣ Convert to percentage (for your positioning system)
      const newWidthPercent = (finalWidthPx / pageWidth) * 100;
      const newHeightPercent = (finalHeightPx / pageHeight) * 100;

      // 4️⃣ Fix Baseline - grow upwards for larger font size
      const oldHeightPx = (currentAnnotation.height / 100) * pageHeight;
      const heightDiffPx = finalHeightPx - oldHeightPx;

      const oldYPercent = currentAnnotation.y;
      const heightDiffPercent = (heightDiffPx / pageHeight) * 100;

      const newYPercent = oldYPercent - heightDiffPercent;

      // 5️⃣ Special Handling for signer_text minimum width
      if (type === "signer_text") {
        const minWidthPx = 100; // Minimum width for signer text
        const minWidthPercent = (minWidthPx / pageWidth) * 100;

        mergedAnnotation.width = Math.max(newWidthPercent, minWidthPercent);
      } else {
        mergedAnnotation.width = newWidthPercent;
      }

      mergedAnnotation.height = newHeightPercent;
      mergedAnnotation.y = newYPercent;
    }

    // ✅ Update annotations state
    setAnnotations((prevAnnotations) => {
      const pageAnnotations = [...(prevAnnotations[pageNum] || [])];
      pageAnnotations[index] = mergedAnnotation;

      return {
        ...prevAnnotations,
        [pageNum]: pageAnnotations,
      };
    });

    // ✅ Sync updated styles to annotationSettings (optional)
    setAnnotationSettings((prevSettings) => ({
      ...prevSettings,
      [selectedAnnotation.type]: {
        ...prevSettings[selectedAnnotation.type],
        ...updatedProps,
      },
    }));

    // ✅ Global `isRequired` handling
    if (updatedProps.isRequired !== undefined) {
      setGlobalIsRequired(updatedProps.isRequired);
    }
  };
  // correct
  const handleUpdateAnnotation = (updatedProps) => {
    if (!selectedAnnotation) return;

    const { pageNum, index } = selectedAnnotation;
    const currentAnnotation = annotations[pageNum][index];

    const type = currentAnnotation.type;

    // Merge current annotation with updated properties
    let mergedAnnotation = {
      ...currentAnnotation,
      ...updatedProps,
    };

    if (
      type === "my_text" ||
      type === "signer_text" ||
      type === "date" ||
      type === "signer_date"
    ) {
      const pageElement = document.querySelector(`#img-${pageNum} .pdf-image`);
      if (!pageElement) return;

      const pageWidth = pageElement.offsetWidth;
      const pageHeight = pageElement.offsetHeight;

      // 1️⃣ Create offscreen span for accurate measurement
      const tempSpan = document.createElement("span");
      tempSpan.style.visibility = "hidden";
      tempSpan.style.position = "absolute";
      tempSpan.style.whiteSpace = "pre";

      const newFontSize =
        updatedProps.fontSize || currentAnnotation.fontSize || 16;
      const newFontFamily =
        updatedProps.fontFamily || currentAnnotation.fontFamily || "Helvetica";
      const newFontWeight = updatedProps.format?.includes("bold")
        ? "bold"
        : "normal";
      const newFontStyle = updatedProps.format?.includes("italic")
        ? "italic"
        : "normal";
      const letterSpacing =
        updatedProps.letterSpacing ||
        currentAnnotation.letterSpacing ||
        "normal";

      tempSpan.style.fontSize = `${newFontSize}px`;
      tempSpan.style.fontFamily = newFontFamily;
      tempSpan.style.fontWeight = newFontWeight;
      tempSpan.style.fontStyle = newFontStyle;
      tempSpan.style.letterSpacing = letterSpacing;

      // 2️⃣ Preserve original baseline before any changes
      const oldHeightPx = (currentAnnotation.height / 100) * pageHeight;
      const baselinePx = currentAnnotation.y * pageHeight + oldHeightPx; // Fixed bottom position

      // 3️⃣ Measure new text size after applying the changes
      const textToMeasure = mergedAnnotation.text || "Text";
      tempSpan.innerText = textToMeasure;

      document.body.appendChild(tempSpan);

      const measuredWidth = tempSpan.getBoundingClientRect().width;
      const measuredHeight = tempSpan.getBoundingClientRect().height;

      document.body.removeChild(tempSpan);

      // 4️⃣ Add consistent padding (same as your MUI TextField)
      const paddingX = 8; // Horizontal padding (left+right)
      const paddingY = 6; // Vertical padding (top+bottom)

      const finalWidthPx = measuredWidth + paddingX * 2;
      const finalHeightPx = measuredHeight + paddingY;

      // 5️⃣ Convert to percentage (for your positioning system)
      const newWidthPercent = (finalWidthPx / pageWidth) * 100;
      const newHeightPercent = (finalHeightPx / pageHeight) * 100;

      let newYPercent = currentAnnotation.y; // Default: Keep Y same

      // 6️⃣ Separate logic for font size changes vs. font family/style changes
      if (updatedProps.fontSize) {
        // ✅ Your logic for font size changes
        const heightDiffPx = finalHeightPx - oldHeightPx;
        const heightDiffPercent = (heightDiffPx / pageHeight) * 100;
        newYPercent = currentAnnotation.y - heightDiffPercent; // Move text upwards when increasing size
      } else if (
        updatedProps.fontFamily ||
        updatedProps.format?.includes("bold") ||
        updatedProps.format?.includes("italic")
      ) {
        // ✅ My logic for font family & style changes (keep baseline fixed)
        newYPercent = (baselinePx - finalHeightPx) / pageHeight;
      }

      // 7️⃣ Special Handling for signer_text minimum width
      if (type === "signer_text") {
        const minWidthPx = 100; // Minimum width for signer text
        const minWidthPercent = (minWidthPx / pageWidth) * 100;

        mergedAnnotation.width = Math.max(newWidthPercent, minWidthPercent);
      } else {
        mergedAnnotation.width = newWidthPercent;
      }

      mergedAnnotation.height = newHeightPercent;
      mergedAnnotation.y = newYPercent; // ✅ Ensures text grows upwards while baseline stays fixed
    }

    // ✅ Update annotations state
    setAnnotations((prevAnnotations) => {
      const pageAnnotations = [...(prevAnnotations[pageNum] || [])];
      pageAnnotations[index] = mergedAnnotation;

      return {
        ...prevAnnotations,
        [pageNum]: pageAnnotations,
      };
    });

    // ✅ Sync updated styles to annotationSettings (optional)
    setAnnotationSettings((prevSettings) => ({
      ...prevSettings,
      [selectedAnnotation.type]: {
        ...prevSettings[selectedAnnotation.type],
        ...updatedProps,
      },
    }));

    // ✅ Global `isRequired` handling
    if (updatedProps.isRequired !== undefined) {
      setGlobalIsRequired(updatedProps.isRequired);
    }
  };

  // Add a class to the main container when annotation mode is active
  const mainContainerClass = isAnnotating ? "custom-cursor" : "";
  // Update the useEffect for cursor handling

  const getSignerCursorContent = (type, color) => {
    // Base styles for the cursor content
    const baseStyles = `
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 4px 8px;
      background-color: ${color}19;
      border: 1px solid ${color};
      border-radius: 4px;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.87);
    `;

    // Icon container styles
    const iconStyles = `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      color: rgba(0, 0, 0, 0.54);
    `;

    return `
      <div style="${baseStyles}">
        <div style="${iconStyles}">
          ${getSignerBoxContent(type)?.icon}
        </div>
        <span>${getSignerBoxContent(type)?.text || ""}</span>
      </div>
    `;
  };

  // Update your useEffect for cursor handling

  const cursorConfig = {
    my_text: { type: "image", image: "/text.png", width: 130, height: 33 },
    my_signature: {
      type: "image",
      image: "/signature11.png",
      width: 250,
      height: 100,
    },
    my_initials: {
      type: "image",
      image: "/initial.png",
      width: 100,
      height: 100,
    },
    date: { type: "image", image: "/date.png", width: 120, height: 30 },
    checkmark: { type: "image", image: "/check.png", width: 30, height: 30 },
    highlight: {
      type: "image",
      image: "/highlight.png",
      width: 120,
      height: 30,
    },
    stamp: { type: "image", image: "/stamp.png", width: 150, height: 150 },
    signer_checkmark: {
      type: "image",
      image: "/check.png",
      width: 30,
      height: 30,
    },

    // For Other - Box based
    signer_initials: { type: "box", color: "#f0f0f0" },
    signer_initials_text: { type: "box", color: "#f0f0f0" },
    signer_chooseImgStamp: { type: "box", color: "#f0f0f0" },
    signer_chooseImgDrivingL: { type: "box", color: "#f0f0f0" },
    signer_chooseImgPassportPhoto: { type: "box", color: "#f0f0f0" },
    // signer_checkmark: { type: "box", color: "#f0f0f0" },
    signer_date: { type: "box", color: "#f0f0f0" },
    signer_text: { type: "box", color: "#f0f0f0" },
    signer_dropdown: { type: "box", color: "#f0f0f0" },
  };

  useEffect(() => {
    if (isAnnotating) {
      // const cursorConfigItem =
      //   cursorConfig[annotationType] || cursorConfig["stamp"];
      const cursorConfigItem =
        cursorConfig[annotationType] || cursorConfig["stamp"];

      if (cursorConfigItem.type === "image") {
        // ---- IMAGE Cursor ----
        const cursorElement = document.createElement("div");
        cursorElement.classList.add("custom-cursor-image");
        cursorElement.style.width = `${cursorConfigItem.width}px`;
        cursorElement.style.height = `${cursorConfigItem.height}px`;
        cursorElement.style.backgroundImage = `url(${cursorConfigItem.image})`;
        document.body.appendChild(cursorElement);
        cursorRef.current = cursorElement;
      } else if (cursorConfigItem.type === "box") {
        // ---- BOX Cursor ----
        const boxElement = document.createElement("div");
        boxElement.classList.add("custom-cursor-box");
        document.body.appendChild(boxElement);
        cursorRef.current = boxElement;

        // Dynamic size map
        const sizeMap = {
          signer_initials: { width: "250px", height: "80px" },
          signer_initials_text: { width: "100px", height: "80px" },
          signer_chooseImgStamp: { width: "150px", height: "100px" },
          signer_chooseImgDrivingL: { width: "350px", height: "120px" },
          signer_chooseImgPassportPhoto: { width: "450px", height: "170px" },
          signer_checkmark: { width: "20px", height: "20px" },
          signer_date: { width: "120px", height: "25px" },
          signer_text: { width: "120px", height: "25px" },
          signer_dropdown: { width: "120px", height: "25px" },
        };

        const { width, height } = sizeMap[annotationType] || {
          width: "120px",
          height: "50px",
        };

        const getPaddingTop = (type) => {
          switch (type) {
            case "signer_chooseImgDrivingL":
              return "78px";
            case "signer_chooseImgPassportPhoto":
              return "128px";
            case "signer_checkmark":
              return "0px";
            case "signer_initials":
            case "signer_initials_text":
            // case "signer_chooseImgStamp":
            case "signer_chooseImgDrivingL":
            case "signer_chooseImgPassportPhoto":
              return "25px";
            case "signer_chooseImgStamp":
              return "50px";
            default:
              return "2px";
          }
        };

        Object.assign(boxElement.style, {
          position: "fixed",
          zIndex: 9999,
          pointerEvents: "none",
          paddingTop: getPaddingTop(annotationType),
          width,
          height,
          backgroundColor: selectedSigner.color,
          // padding: annotationType === "signer_checkmark" ? "5px" : null,
          border: "1px solid rgba(0,0,0,0.2)",
          opacity: 0.6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "Arial",
          fontWeight: "bold",
          color: "#000",
          borderRadius: "4px",
          // padding: annotationType === "signer_checkmark" ? "5px" : "0px",
        });

        // Dynamic content rendering per type
        if (annotationType === "signer_checkmark") {
          // boxElement.innerHTML = `
          //   <div style="width: 20px; height: 20px; border: 2px solid black; background-color: white;margin:2px"></div>
          // `;
          boxElement.innerHTML = `
        <div style="
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${selectedSigner.color};
            border-radius: 4px;
            box-sizing: border-box;
            /* This is the padding behind the checkbox */
        ">
            <div style="
                width: 20px;
                height: 20px;
                background-color: white;
                border: 2px solid black;
                box-sizing: border-box;
            "></div>
        </div>
    `;
        } else if (annotationType === "signer_date") {
          // boxElement.innerHTML = `
          //   <div style="font-size: 16px; font-weight: 400;padding-left:2px;">Date</div>
          // `;
          boxElement.innerHTML = `
          <div style="
            font-size: 16px;
            font-weight: 400;
            padding-left: 2px;
            padding-right: 2px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            height: 100%;
          ">
            Date...
            <div style="
              position: absolute;
              bottom: 2px;
              left: 0;
              width: calc(100% - 4px); 
              height: 1px;
              background-color: black;
            "></div>
          </div>
        `;
        } else if (annotationType === "signer_text") {
          boxElement.innerHTML = `
            <div style="font-size: 18px; font-weight: 400; padding-left:4px;padding-top:2px;text-decoration: none;">Text ...</div>
          `;
        } else if (annotationType === "signer_dropdown") {
          boxElement.innerHTML = `
            <div style="font-size: 18px; font-weight: 400; padding-left:4px;padding-top:2px;text-decoration: none;">Dropdown ...</div>
          `;
        } else {
          const boxContent = getSignerBoxContentSvg(annotationType);
          if (boxContent) {
            boxElement.innerHTML = `
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;">
                ${boxContent.icon}
                <div style="font-size: 21px; font-weight: 400;">${boxContent.text}</div>
              </div>
            `;
          }
        }
      }

      const moveCursor = (e) => {
        const target = e.target;
        if (isResizing) {
          cursorRef.current.style.display = "none";
          // document.body.style.cursor = "default";
          // document.body.style.cursor = window.getComputedStyle(target).cursor;
          return;
        }
        if (target.closest(".react-rnd-resizable-handle")) {
          cursorRef.current.style.display = "none";
          document.body.style.cursor = window.getComputedStyle(target).cursor;
          return;
        }
        // Check for all cases where we should hide custom cursor
        const shouldHideCustomCursor =
          // Text fields
          target.tagName === "INPUT" ||
          target.closest(".MuiTextField-root") ||
          // Annotations
          target.closest(".annotation") ||
          // Resize handles
          // target.closest(".react-rnd-resizable-handle") ||
          // Edit/Delete buttons
          target.closest(".MuiIconButton-root") ||
          target.closest('[aria-label="edit"]') ||
          target.closest('[aria-label="close"]') ||
          // Sidebars
          target.closest(".left-sidebar") ||
          target.closest(".right-sidebar") ||
          target.closest(".zoom-container");

        // Check if we're in the PDF container
        const isPdfContainer = target.closest(".pdf-container");

        if (shouldHideCustomCursor) {
          // Hide custom cursor
          cursorRef.current.style.display = "none";
          document.body.style.cursor = getCursorForElement(target);
          // Set appropriate cursor style
          // if (target.closest(".react-rnd-resizable-handle")) {
          //   document.body.style.cursor = "nw-resize";
          // } else
          if (target.classList.contains("annotation-resize-handle")) {
            cursorRef.current.style.display = "none"; // Hide your custom cursor
            document.body.style.cursor = window.getComputedStyle(target).cursor;
            return;
          }
          if (target.closest(".react-rnd-resizable-handle")) {
            cursorRef.current.style.display = "none"; // Hide custom cursor
            document.body.style.cursor = window.getComputedStyle(target).cursor;
            return; // Let Rnd's default cursor handling work
          }
          if (
            target.closest(".MuiIconButton-root") ||
            target.closest('[aria-label="edit"]') ||
            target.closest('[aria-label="close"]')
          ) {
            document.body.style.cursor = "pointer";
          } else if (target.closest(".annotation")) {
            document.body.style.cursor = "move";
          } else if (
            target.tagName === "INPUT" ||
            target.closest(".MuiTextField-root")
          ) {
            document.body.style.cursor = "text";
          } else {
            document.body.style.cursor = "default";
          }
        } else if (isPdfContainer) {
          // Show custom cursor only in PDF container and not over any special elements
          cursorRef.current.style.display = "block";
          cursorRef.current.style.left = `${e.clientX}px`;
          cursorRef.current.style.top = `${e.clientY}px`;
          document.body.style.cursor = "none";
        } else {
          // Hide custom cursor outside PDF container
          cursorRef.current.style.display = "none";
          document.body.style.cursor = "default";
        }
      };

      const getCursorForElement = (target) => {
        if (target.closest(".react-resizable-handle"))
          return window.getComputedStyle(target).cursor;
        if (
          target.closest(".MuiIconButton-root") ||
          target.closest('[aria-label="edit"]') ||
          target.closest('[aria-label="close"]')
        ) {
          return "pointer";
        }
        if (target.closest(".annotation")) return "move";
        if (target.tagName === "INPUT" || target.closest(".MuiTextField-root"))
          return "text";
        return "default";
      };

      document.addEventListener("mousemove", moveCursor);

      return () => {
        document.removeEventListener("mousemove", moveCursor);
        if (cursorRef.current?.parentNode) {
          document.body.removeChild(cursorRef.current);
          cursorRef.current = null;
        }
        document.body.style.cursor = "default";
      };
    }
  }, [isAnnotating, annotationType]);
  const splitEmailIntoLines = (email) => {
    if (!email) return [];

    const chunkSize = 13;
    const lines = [];

    for (let i = 0; i < email.length; i += chunkSize) {
      lines.push(email.substring(i, i + chunkSize));
    }

    return lines;
  };
  const cursorTypes = {
    my_text: {
      className: "custom-cursor-image",
      imageUrl: "/public/text.png",
      width: "150px",
      height: "30px",
    },
    highlight: {
      className: "custom-cursor-image-highlight",
      imageUrl: "/public/highlight.png",
      width: "150px",
      height: "30px",
    },
    stamp: {
      className: "custom-cursor-image-stamp",
      imageUrl: "/public/stamp.png",
      width: "150px",
      height: "150px",
    },
    my_signature: {
      className: "custom-cursor-image-signature",
      imageUrl: "/public/signature11.png",
      width: "250px",
      height: "100px",
    },
    my_initials: {
      className: "custom-cursor-image-initials",
      imageUrl: "/public/initial.png",
      width: "100px",
      height: "100px",
    },
    checkmark: {
      className: "custom-cursor-image-check",
      imageUrl: "/public/check.png",
      width: "30px",
      height: "30px",
    },
    date: {
      className: "custom-cursor-image-date",
      imageUrl: "/public/check.png",
      width: "30px",
      height: "30px",
    },
    signer_text: {
      className: "custom-cursor-image-signer-text",
      imageUrl: "/public/text.png",
      width: "150px",
      height: "30px",
    },
    signer_initials: {
      className: "custom-cursor-image-signer-signature",
      imageUrl: "/public/signature11.png",
      width: "250px",
      height: "100px",
    },
    signer_initials_text: {
      className: "custom-cursor-image-signer-initials",
      imageUrl: "/public/initial.png",
      width: "100px",
      height: "100px",
    },
    signer_date: {
      className: "custom-cursor-image-signer-date",
      imageUrl: "/public/date.png",
      width: "30px",
      height: "30px",
    },
    signer_checkmark: {
      className: "custom-cursor-image-signer-check",
      imageUrl: "/public/check.png",
      width: "30px",
      height: "30px",
    },
    signer_chooseImgStamp: {
      className: "custom-cursor-image-signer-stamp",
      imageUrl: "/public/stamp.png",
      width: "150px",
      height: "150px",
    },
  };
  const downloadPdfWithAnnotations = async () => {
    try {
      const previousScale = scale;
      setScale(1);
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const formData = new FormData();
      formData.append("pdfFile", pdfFile);

      // const annotationsData = {};
      const annotationsArray = [];
      Object.entries(annotations).forEach(([pageNum, pageAnnotations]) => {
        const imageElem = document.querySelector(`#img-${pageNum} .pdf-image`);
        const imageRect = imageElem.getBoundingClientRect();
        const naturalWidth = imageElem.naturalWidth;
        const naturalHeight = imageElem.naturalHeight;

        pageAnnotations.forEach((annot) => {
          const width_data = annot.width;
          const height_data = annot.height;
          const xPercent = (annot.x / imageRect.width) * 100;
          const yPercent = (annot.y / imageRect.height) * 100;

          annotationsArray.push({
            // Position properties
            // x: xPercent,
            // y: yPercent,
            x: annot.x,
            y: annot.y,
            width: annot.width,
            height: annot.height,
            dpi: annot.dpi,
            page_no: parseInt(pageNum),

            // Content properties
            text: annot.text,
            type: annot.type,
            imageUrl: annot.imageUrl,
            checked: annot.checked,

            // Text formatting properties
            fontSize: annot.fontSize || 16,
            fontFamily: annot.fontFamily || "Arial",
            color: annot.color || "#000000",
            format: annot.format || [],
            letterSpacing: annot.letterSpacing || 0,
            alignment: annot.alignment,
            opacity: annot.opacity || 1,

            // Style properties
            backgroundColor: annot.backgroundColor,
            borderColor: annot.borderColor,

            // Signer properties
            signerId: annot.signerId,
            signerName: annot.signerName,
            signerColor: annot.signerColor,
            isRequired: annot.isRequired,

            // Date specific properties
            dateFormat: annot.dateFormat,
            date: annot.date,

            // Dropdown specific properties
            options: annot.options,

            // Signature/Image specific properties
            isSignature: annot.isSignature,
            aspectRatio: annot.aspectRatio,

            // Additional properties
            id: annot.id,
            scale: annot.scale,
          });
        });
      });
      console.log("annotationsArray", annotationsArray);

      let response_log1 = await getActivityLogUserFiles({
        file_id: documentId,
        email: user_email,
        event: "COMPLETED-DOCUMENT",
        description: `${fileName} completed  `,
        status: "selfsigned",
      });
      formData.append(
        "annotations",
        // JSON.stringify({
        //   annotations: annotationsArray,
        // })
        JSON.stringify({
          annotations: annotationsArray,
          // activityLog: response_log1, // Add activity log data
          documentInfo: {
            uniqId: uniqIdDoc,
            fileName: fileName,
            logo: null,
          },
        })
      );

      const response = await fetch(
        "http://localhost:3004/generate-annotated-pdf11",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("PDF generation failed");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "annotated-document.pdf";
      link.click();
      URL.revokeObjectURL(url);
      setScale(previousScale);
    } catch (error) {
      console.error("Error creating PDF:", error);
    }
  };

  // In your App component
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingC, setIsDownloadingC] = useState(false);

  // completedDoc

  const handleDownloadCompleted = async () => {
    // const pdfUrl = apiData?.result[0]?.image;
    if (!completedDoc) return;

    setIsDownloadingC(true);
    try {
      const success = await downloadOriginalPdf(completedDoc, fileName);
      if (!success) {
        toastAlert("error", "Failed to download PDF");
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toastAlert("error", "Failed to download PDF");
    } finally {
      setIsDownloadingC(false);
    }
  };
  const handleDownloadOriginal = async () => {
    // const pdfUrl = apiData?.result[0]?.image;
    if (!originalPdf) return;

    setIsDownloading(true);
    try {
      const success = await downloadOriginalPdf(originalPdf, fileName);
      if (!success) {
        toastAlert("error", "Failed to download PDF");
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toastAlert("error", "Failed to download PDF");
    } finally {
      setIsDownloading(false);
    }
  };
  // hashed ids
  return (
    <>
      {isLoading && <FullScreenLoader />}

      <Box className={mainContainerClass}>
        {/* Add this near the end of your return statement, alongside other modals */}

        <input
          type="file"
          ref={stampInputRef}
          style={{ display: "none" }}
          accept="image/*"
          onChange={handleStampFileSelect} // Remove lastClickPosition parameter
        />
        <FileUpload
          handleDownloadCompleted={handleDownloadCompleted}
          viewDoc={true}
          setFileName={(name) => setFileName(name)}
          emailSubject={emailSubject}
          setEmailSubject={setEmailSubject}
          emailMessage={emailMessage}
          setEmailMessage={setEmailMessage}
          originalPdf={originalPdf}
          uniqIdDoc={uniqIdDoc}
          user_email={user_email}
          file_id={documentId}
          annotations={annotations}
          signers={signers}
          setSigners={setSigners}
          user_id={userId}
          file_name={fileName || "Document"}
          // pdfUrl="https://y5f8.c1.e2-7.dev/requiresign-testing-bucket/112316_riazirim22%2F20241106%2F0019_Invoice-2C6D4BDF-0024.pdf" // Add your PDF URL here
          onDownloadOriginal={handleDownloadOriginal}
          isDownloading={isDownloading}
          isDownloadingC={isDownloadingC}
        />

        {!pdfFile ? (
          <></>
        ) : (
          <Grid2 container spacing={0} height="90vh">
            {/* Left Sidebar */}
            <Grid2
              item
              xs={2}
              ref={sidebarRef}
              sx={styles.sidebarStyle}
              onMouseDown={(e) => e.stopPropagation()}
              onMouseUp={(e) => e.stopPropagation()}
              className="left-sidebar"
            >
              <Button
                variant="contained"
                component="span"
                onClick={async () => {
                  window.location.href = `${FrontendBaseUrl}home`;
                }}
                sx={{
                  textTransform: "none",
                  color: "white",
                  width: "100%",
                  cursor: "pointer !important",
                  fontWeight: 600,
                  backgroundColor: colortheme,
                  // marginLeft: "20px",
                  boxShadow: "none",
                  marginBottom: "10px",

                  position: "relative", // Add this for loader positioning
                  "&:hover": {
                    boxShadow: "none",
                    backgroundColor: colortheme,
                    cursor: "pointer !important",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: colortheme,
                    color: "white",
                  },
                }}
              >
                Back
              </Button>

              {/* signers  */}

              {signers.length === 0 ? null : (
                <>
                  {signers.map((signer, index) => (
                    <ListItem
                      sx={{
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        mb: 1,
                        display: "flex",
                        alignItems: "center",

                        "&:hover": {
                          background: "rgba(0, 0, 0, 0.02)",
                        },
                      }}
                    >
                      <ListItemText
                        primary={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{ color: "text.secondary" }}
                            >
                              #{signer.order_id}
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: 500 }}
                            >
                              {signer.name}
                            </Typography>
                          </Box>
                        }
                        secondary={
                          <Box sx={{ mt: 0.5 }}>
                            {splitEmailIntoLines(signer.email).map(
                              (line, index) => (
                                <Typography
                                  component="span"
                                  variant="body2"
                                  key={index}
                                >
                                  {line}
                                  <br />
                                </Typography>
                              )
                            )}
                            <br />
                            <Typography
                              component="span"
                              variant="body2"
                              sx={{
                                fontSize: "12px",
                              }}
                            >
                              Access Code:{" "}
                            </Typography>
                            <Chip
                              label={`${signer.access_code || "Not set"}`}
                              size="small"
                              sx={{
                                height: "20px",
                                fontFamily: "monospace",
                                fontSize: "12px",
                                backgroundColor: signer.access_code
                                  ? "rgba(44, 62, 80, 0.1)"
                                  : "rgba(149, 165, 166, 0.1)",
                                color: signer.access_code
                                  ? "#2c3e50"
                                  : "#95a5a6",
                                "& .MuiChip-label": {
                                  px: 1,
                                },
                              }}
                            />
                          </Box>
                        }
                      />
                    </ListItem>
                  ))}
                </>
              )}

              {/* end  */}
            </Grid2>
            {/* Main PDF Viewer */}
            <Grid2 xs={8} className="main-container">
              <Grid2
                item
                // className="pdf-container"
                className={`pdf-container ${
                  isAnnotating ? "custom-cursor" : ""
                }`}
                ref={pdfContainerRef}
                onClick={handlePdfClick} // Enable click for annotations if in annotation mode
              >
                <Box
                  className="pdf-content-box"
                  sx={{
                    minWidth:
                      scale > 1
                        ? `${100 * scale}%`
                        : `${calculateImageWidth(scale)}%`,
                    maxWidth: scale > 1 ? `${100 * scale}%` : "100%",
                    position: "relative",
                    overflow: scale > 1 ? "auto" : "hidden",
                    // minWidth: `${calculateImageWidth(scale)}%`,
                    alignContent: scale <= 1 ? "center" : "flex-start",
                    justifyContent: scale <= 1 ? "center" : "flex-start",
                    alignItems: scale <= 1 ? "center" : "flex-start",
                    display: scale <= 1 ? "flex" : "block",

                    transformOrigin: "top left",
                  }}
                >
                  {pdfImages.length > 0 ? (
                    pdfImages.map((image, index) => (
                      <div
                        key={index}
                        className="pdf-page-container"
                        id={`img-${index + 1}`}
                        onMouseEnter={() => handlePageHover(index + 1)}
                        style={{
                          width: `${calculateImageWidth(scale)}%`,
                          position: "relative",
                        }} // Ensure relative positioning
                      >
                        {renderImage(image, index)}
                        {/* Pass the page number directly */}
                        {/* {renderAnnotations(index + 1)} */}
                      </div>
                    ))
                  ) : (
                    <Typography>Loading PDF...</Typography>
                  )}
                </Box>
              </Grid2>
            </Grid2>
            {/* Right Sidebar */}
            <Grid2
              item
              xs={2}
              className="right-sidebar"
              ref={sidebarRef}
              sx={styles.sidebarStyle}
            >
              {/* start  */}
              {selectedAnnotation &&
                (selectedAnnotation?.type === "my_text" ||
                  selectedAnnotation?.type === "signer_text") && (
                  <>
                    <TextPropertiesPanel
                      closeButton={() => {
                        setSelectedAnnotation(null);
                        setAnnotationType(null);
                        setIsAnnotating(false);
                      }}
                      type={annotationType}
                      selectedAnnotation={selectedAnnotation}
                      onUpdateAnnotation={handleUpdateAnnotation}
                      setTextFieldMetrics={setTextFieldMetrics}
                      setAnnotationSettings={setAnnotationSettings}
                      scale={scale}
                    />
                  </>
                )}
              {selectedAnnotation?.type === "signer_dropdown" && (
                <DropdownPropertiesPanel
                  selectedAnnotation={selectedAnnotation}
                  onUpdateAnnotation={handleUpdateAnnotation}
                  closeButton={() => {
                    setSelectedAnnotation(null);
                    setAnnotationType(null);
                    setIsAnnotating(false);
                  }}
                />
              )}
              {(selectedAnnotation?.type === "signer_initials" ||
                selectedAnnotation?.type === "signer_initials_text" ||
                selectedAnnotation?.type === "signer_chooseImgStamp" ||
                selectedAnnotation?.type === "signer_chooseImgDrivingL" ||
                // selectedAnnotation?.type === "signer_checkmark" ||
                selectedAnnotation?.type ===
                  "signer_chooseImgPassportPhoto") && (
                <SignerFieldProperties
                  selectedAnnotation={selectedAnnotation}
                  onUpdateAnnotation={handleUpdateAnnotation}
                  closeButton={() => {
                    setSelectedAnnotation(null);
                    setAnnotationType(null);
                    setIsAnnotating(false);
                  }}
                />
              )}
              {selectedAnnotation &&
                (selectedAnnotation.type === "date" ||
                  selectedAnnotation.type === "signer_date") && (
                  <DatePickerComponent
                    selectedAnnotation={selectedAnnotation}
                    onUpdateAnnotation={handleUpdateAnnotation}
                    type={selectedAnnotation.type}
                    closeButton={() => {
                      setSelectedAnnotation(null);
                      setAnnotationType(null);
                      setIsAnnotating(false);
                    }}
                  />
                )}

              {/* end  */}
              {!selectedAnnotation?.type?.startsWith("signer_") &&
                selectedAnnotation?.type !== "my_text" &&
                selectedAnnotation?.type !== "date" && (
                  <>
                    <Typography variant="h6">Preview</Typography>
                    {pdfImages.length > 0 &&
                      pdfImages.map((image, index) => (
                        <>
                          <Box
                            key={index}
                            sx={{
                              scrollMarginTop: "8px",
                              scrollMarginBottom: "8px",
                              transition: "all 0.1s ease",
                            }}
                            id={`thumbnail-${index + 1}`}
                            className={`thumbnail-container ${
                              activePage === index + 1 ? "active" : ""
                            }`}
                            onClick={() => {
                              document
                                .getElementById(`img-${index + 1}`)
                                .scrollIntoView({ behavior: "smooth" });
                              setActivePage(index + 1);
                            }}
                          >
                            {renderImage(image, index, false)}
                          </Box>
                          <p
                            className={`page-number ${
                              activePage === index + 1 ? "active" : ""
                            }`}
                          >
                            Page {index + 1}
                          </p>
                        </>
                      ))}{" "}
                  </>
                )}
            </Grid2>{" "}
          </Grid2>
        )}
        {signatureModalOpen && (
          <Dialog
            open={signatureModalOpen}
            onClose={() => {
              console.log("close mic ");
              setSignatureModalOpen(false);
              setAnnotations((prev) => {
                const pageAnnotations = prev[activePage] || [];
                return {
                  ...prev,
                  [activePage]: pageAnnotations.filter((a) => !a.isLoading),
                };
              });
            }}
            maxWidth="md"
            fullWidth
          >
            <SignatureModalContent
              initialsBox={initialsBox}
              profile={false}
              returnedSignature={handleSignatureComplete}
              modalClosingD={() => {
                setSignatureModalOpen(false);
                console.log("close meet");
                setAnnotations((prev) => {
                  const pageAnnotations = prev[activePage] || [];
                  return {
                    ...prev,
                    [activePage]: pageAnnotations.filter((a) => !a.isLoading),
                  };
                });
              }}
              modalClose={() => {
                setSignatureModalOpen(false);
                console.log("close m");
                // setAnnotations((prev) => {
                //   const pageAnnotations = prev[activePage] || [];
                //   return {
                //     ...prev,
                //     [activePage]: pageAnnotations.filter((a) => !a.isLoading),
                //   };
                // });
              }}
              user_id_user={userId} // Replace with actual user ID if needed
              user_email="rimshanimo22@gmail.com"
            />
          </Dialog>
        )}
      </Box>
      {/* // Add this instead (place it next to your other Dialog components): */}
      <Dialog
        open={cropperModalOpen}
        onClose={() => {
          setCropperModalOpen(false);
          setCropSrc(null);
          setPendingStampAction(null);
          setStampClickPosition(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Crop Image
          {/* <IconButton
            aria-label="close"
            onClick={() => {
              setCropperModalOpen(false);
              setCropSrc(null);
              setPendingStampAction(null);
              setStampClickPosition(null);
            }}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton> */}
        </DialogTitle>
        <DialogContent>
          <ImageCropperModal
            cropSrc={cropSrc}
            isOpen={cropperModalOpen}
            toggle={() => {
              setCropperModalOpen(false);
              setCropSrc(null);
              setPendingStampAction(null);
              setStampClickPosition(null);
            }}
            onImageCropped={handleCroppedStamp}
          />
        </DialogContent>
      </Dialog>
      {/* // Add the SignersDialog component in your return statement (near other dialogs) */}
      <SignersDialog
        annotations={annotations}
        setAnnotationsd={async (newAnnotations) => {
          console.log("Updating annotations:", newAnnotations);
          setAnnotations(newAnnotations);
          await saveData(documentId, newAnnotations);
        }}
        open={signersDialogOpen}
        onClose={() => {
          setSignersDialogOpen(false);
          setSignerToEdit(null); // Clear edit state on close
        }}
        signers={signers}
        file_id={documentId}
        setSigners={setSigners}
        signerToEdit={signerToEdit}
      />
    </>
  );
}

export default EsignSetupView;
